import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.xray.normality_review');
import { ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Service } from "src/libs/portal/season/service";
import {
    XRAY_OPERATING_POSE_CONNECTIONS,
    XRAY_OPERATING_POSE_STYLE,
} from "src/libs/portal/season/xray-pose-skeleton";


const POSTURE_CLASSES = [
    {
        key: 'NORMAL', label: '정상 자세', short: '정상',
        description: '자세와 디텍터의 중심·높이·범위·밀착 관계가 모두 적절함',
    },
    {
        key: 'SHOULDER_DETECTOR_RELATION', label: '1. 어깨·디텍터 범위 이상', short: '어깨·범위',
        description: '어깨가 촬영 범위를 벗어나거나 좌우 어깨가 기울고 상체가 틀어진 상태',
    },
    {
        key: 'SPINE_CENTER_ALIGNMENT', label: '2. 몸 치우침·척추 중심 이탈', short: '척추·중심',
        description: '어깨·폐첨부에 치중해 몸이 좌우로 치우치고 척추가 디텍터 중심선에 놓이지 못한 상태',
    },
    {
        key: 'UPPER_DETECTOR_CHIN_CONTACT', label: '3. 상단·턱·밀착 관계 이상', short: '상단·턱·밀착',
        description: '디텍터가 너무 높거나 턱을 못 들어 두부·턱이 흉부/폐첨부를 가리거나, 몸과 디텍터가 밀착되지 않은 상태',
    },
    {
        key: 'LOWER_DETECTOR_CHEST_CROP', label: '4. 하단·흉부 잘림', short: '하단·흉부',
        description: '디텍터가 환자 중심보다 낮아 흉부가 촬영 범위에서 잘린 상태',
    },
];
const ABNORMAL_CLASSES = POSTURE_CLASSES.filter(row => row.key !== 'NORMAL');
const PRIORITY_IDS = new Set([0, 11, 12, 13, 14, 15, 16, 23, 24]);
const AI_POSTURE_VIDEO_IDS = new Set([11, 12, 13, 14, 23, 24]);
const AI_POSTURE_KEY_IDS = [11, 12, 13, 14, 23, 24];
const AI_POSTURE_PRIMARY_IDS = [11, 12, 13, 14];
const AI_POSTURE_SHOULDER_IDS = [11, 12];
const AI_POSTURE_ELBOW_IDS = [13, 14];
const AI_POSTURE_CONNECTIONS: ReadonlyArray<readonly [number, number]> = [
    [11, 12], [11, 13], [12, 14], [11, 23], [12, 24], [23, 24],
];
const AI_POSTURE_POSE_MODEL_ID = 'mediapipe-pose-landmarker-full-float16-v1';
const DETECTOR_CORNERS = ['top_left', 'top_right', 'bottom_right', 'bottom_left'];
const CORNER_LABELS: any = { top_left: '좌상', top_right: '우상', bottom_right: '우하', bottom_left: '좌하' };
const KO_NAMES = [
    '머리 중심(코)', '왼쪽 눈 안쪽', '왼쪽 눈', '왼쪽 눈 바깥', '오른쪽 눈 안쪽', '오른쪽 눈', '오른쪽 눈 바깥',
    '왼쪽 귀', '오른쪽 귀', '입 왼쪽', '입 오른쪽', '왼쪽 어깨', '오른쪽 어깨', '왼쪽 팔꿈치',
    '오른쪽 팔꿈치', '왼쪽 손목', '오른쪽 손목', '왼쪽 새끼손가락', '오른쪽 새끼손가락',
    '왼쪽 검지', '오른쪽 검지', '왼쪽 엄지', '오른쪽 엄지', '왼쪽 골반', '오른쪽 골반',
    '왼쪽 무릎', '오른쪽 무릎', '왼쪽 발목', '오른쪽 발목', '왼쪽 발뒤꿈치',
    '오른쪽 발뒤꿈치', '왼쪽 발끝', '오른쪽 발끝',
];

type PoseFilterAxisState = {
    raw: number;
    filtered: number;
    derivative: number;
    timestamp: number;
    microDirection: number;
    microFrames: number;
};
type PosePointState = {
    x: PoseFilterAxisState;
    y: PoseFilterAxisState;
    lastVisibleAt: number;
    confidence: number;
};
type SavedPoseSceneTrackingState = {
    lastSourceTime: number;
    lastPose: any[];
    discontinuityFrames: number;
};


@Component({ standalone: false,
    selector: 'wiz-page-xray-normality_review',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.xray.normality_review/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.pose-review-shell.pose-focused {
  min-height: 100vh;
  background: radial-gradient(circle at 55% 35%, rgba(14, 165, 233, 0.07), transparent 32rem), #f8fafc;
  color: #0f172a;
}

.pose-focused .pose-review-header {
  position: sticky;
  top: 0;
  z-index: 60;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
}

.pose-focused .pose-review-header > div {
  max-width: none;
  padding: 0.55rem 0.75rem;
}

.pose-focused .pose-review-main {
  max-width: none;
  padding: 0.5rem;
}

.pose-focused .pose-review-summary {
  gap: 0.5rem;
}

.pose-focused .pose-review-summary > div {
  padding: 0.75rem !important;
  box-shadow: 0 6px 18px rgba(15, 23, 42, 0.05);
}

.pose-focused .pose-review-workspace {
  display: grid;
  grid-template-columns: minmax(220px, 17vw) minmax(480px, 1fr) minmax(300px, 22vw);
  align-items: start;
  gap: 0.5rem;
  min-height: calc(100vh - 10.5rem);
}

.pose-focused .pose-review-queue,
.pose-focused .pose-review-stage,
.pose-focused .pose-review-inspector {
  min-width: 0;
  max-height: calc(100vh - 10.5rem);
}

.pose-focused .pose-review-queue,
.pose-focused .pose-review-stage,
.pose-focused .pose-review-inspector > section {
  border-color: #dbe4ee !important;
  background: #ffffff !important;
  color: #0f172a;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.08);
}

.pose-focused .pose-review-queue,
.pose-focused .pose-review-inspector {
  position: sticky;
  top: 9.5rem;
}

.pose-focused .pose-review-queue > div:last-child {
  max-height: calc(100vh - 16rem) !important;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.pose-focused .pose-review-stage {
  padding: 0.65rem;
  overflow-x: hidden !important;
  overflow-y: auto !important;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.pose-focused .pose-review-media-viewport {
  min-height: 34rem !important;
  max-height: calc(100vh - 22rem) !important;
  background: #f1f5f9 !important;
  overscroll-behavior: contain;
}

.pose-focused .pose-review-media-viewport img,
.pose-focused .pose-review-media-viewport video {
  max-height: calc(100vh - 22rem) !important;
  height: auto;
  object-fit: contain;
}

.pose-focused .pose-review-stage > div > div:first-child {
  color: #334155 !important;
}

.pose-focused .pose-review-stage > div > div:first-child button {
  border-color: #94a3b8 !important;
  background: #ffffff;
  color: #334155 !important;
}

.pose-focused [data-testid=pose-video-temporal-review] {
  border-color: #6ee7b7 !important;
  background: #ecfdf5 !important;
  color: #065f46 !important;
}

.pose-focused .pose-review-inspector {
  overflow-y: auto;
  padding-right: 0.2rem;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
}

.pose-focused .pose-review-inspector > section {
  padding: 0.8rem !important;
}

@media (max-width: 1180px) {
  .pose-focused .pose-review-workspace {
    grid-template-columns: 220px minmax(440px, 1fr);
  }
  .pose-focused .pose-review-inspector {
    position: static;
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    max-height: none;
    overflow: visible;
  }
}
@media (max-width: 760px) {
  .pose-focused .pose-review-summary,
  .pose-focused .pose-review-workspace,
  .pose-focused .pose-review-inspector {
    grid-template-columns: minmax(0, 1fr);
  }
  .pose-focused .pose-review-queue,
  .pose-focused .pose-review-inspector {
    position: static;
    max-height: none;
  }
}`],
})
export class PageXrayNormality_reviewComponent implements OnInit, OnDestroy {
    private readonly runtimeApi = '/wiz/api/page.xray.normality_review_runtime_v14/';
    public readonly operatingPoseStyle = XRAY_OPERATING_POSE_STYLE;
    public summary: any = {};
    public items: any[] = [];
    public current: any = null;
    public currentIndex = 0;
    public statusFilter = 'UNREVIEWED';
    public decisionFilter = '';
    public poseOnlyMode = false;
    public mediaFilter: 'image' | 'video' = 'image';
    public draft: any = this.emptyDraft();
    public loading = false;
    public saving = false;
    public savingAction: 'current' | 'next' | '' = '';
    public loadingNext = false;
    public uploadBusy = false;
    public uploadProgress = { current: 0, total: 0 };
    public notice = '';
    public errorMessage = '';
    public selectedPointId = 11;
    public showAllPoints = false;
    public editLayer: 'pose' | 'detector' = 'pose';
    public detectorCaptureMode = false;
    public detectorCaptureIndex = 0;
    public baseImageDisplay: any = { width: 0, height: 0 };
    public zoomScale = 1;
    public zoomMode: 'full' | 'manual' | 'upper' | 'detector' = 'full';
    public videoPlaying = false;
    public videoAtReviewFrame = true;
    public videoCurrentTime = 0;
    public videoLoadError = false;
    public videoPreparing = false;
    public videoObjectUrl = '';
    public livePoseKeypoints: any[] = [];
    public liveDetectorPolygon: any = null;
    public liveInferenceBusy = false;
    public liveInferenceActive = false;
    public liveInferenceError = '';
    public liveInferenceCount = 0;
    public liveInferenceSourceTime = 0;
    public livePoseBackend = '';
    public livePoseCorrectionApplied = false;
    public videoPoseCorrections: any[] = [];
    public videoDetectorLabels: any[] = [];
    public livePoseTrackingHeldCount = 0;
    public livePoseSwapCorrected = false;
    public livePoseSkeletonConstrainedCount = 0;
    public livePoseCorrectionDrift = 0;
    public livePoseCorrectionGuarded = false;
    public livePoseSceneContinuation = false;
    public reviewFramePoseSuggestion: any[] = [];
    public poseSuggestionSource = '';
    public videoFrameRetargeting = false;
    private pendingVideoFrame: any = null;
    private requestedReviewItemId = '';
    private dragMode: 'pose' | 'detector-corner' | 'detector-move' | '' = '';
    private dragHandle = '';
    private dragPointId = -1;
    private dragStart: any = null;
    private moveHandler = (event: PointerEvent) => this.onPointerMove(event);
    private upHandler = () => this.endDrag();
    private resizeHandler = () => this.updateBaseImageSize(false);
    private detailCache = new Map<string, any>();
    private detailRequests = new Map<string, Promise<any>>();
    private videoLoadVersion = 0;
    private videoPlaybackStarted = false;
    private liveInferenceGeneration = 0;
    private liveInferenceTimer: any = null;
    private readonly liveInferenceDelayMs = 0;
    private readonly liveCaptureMaxWidth = 640;
    private readonly liveTrackingId = 'normality-review-' + Math.random().toString(36).slice(2, 12);
    private aiPosturePoseWorker: Worker | null = null;
    private aiPosturePoseWorkerReady = false;
    private aiPosturePoseWorkerReadyPromise: Promise<void> | null = null;
    private aiPosturePoseAccelerated = false;
    private aiPosturePoseTimestamp = 0;
    private aiPostureFrameContext: any = null;
    private aiPosturePointStates = new Map<number, PosePointState>();
    private aiPostureMedianWindows = new Map<number, { x: number[]; y: number[] }>();
    private previousStablePoseKeypoints: any[] = [];
    private savedPoseSceneTrackingState: SavedPoseSceneTrackingState | null = null;
    private pausedPoseRefinementTime = -1;
    private pausedPoseRefinementSamples: any[][] = [];
    private pausedPoseRefinementTimer: any = null;
    private readonly pausedPoseRefinementTarget = 3;
    private readonly aiPostureWorkerInitTimeoutMs = 30000;
    private readonly aiPostureLowConfidenceHoldMs = 220;
    private readonly aiPostureShoulderHoldMs = 420;
    private readonly aiPostureCoreConfidenceMin = .3;
    private readonly aiPostureShoulderConfidenceMin = .42;
    private readonly aiPostureStaticDeadband = .002;
    private readonly aiPostureShoulderDeadband = .003;
    private readonly aiPostureMicroMotionReleaseFrames = 2;
    private readonly aiPostureMedianWindowSize = 3;
    private readonly poseCorrectionDriftLimit = .30;
    private readonly poseSceneTrackingMaxFrameGapSeconds = .75;
    private readonly poseSceneTrackingMaxCenterStep = .8;
    private readonly poseSceneTrackingMinScaleRatio = .65;
    private readonly poseSceneTrackingMaxScaleRatio = 1.55;
    private readonly poseSceneTrackingMaxTorsoDrift = .6;
    private readonly poseSceneTrackingDiscontinuityFrames = 2;

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef)         public ref: ChangeDetectorRef,@Inject( Router)         public router: Router,@Inject( TranslateService    )         public translate: TranslateService    ) {}

    public async ngOnInit() {
        await this.service.init(this);
        const query = new URLSearchParams(window.location.search);
        this.poseOnlyMode = query.get('mode') === 'pose';
        this.mediaFilter = query.get('media') === 'video' ? 'video' : 'image';
        if (!this.poseOnlyMode) {
            this.statusFilter = 'UNREVIEWED';
            this.decisionFilter = '';
        }
        this.requestedReviewItemId = query.get('review_item') || '';
        document.addEventListener('pointermove', this.moveHandler);
        document.addEventListener('pointerup', this.upHandler);
        window.addEventListener('resize', this.resizeHandler);
        await this.load();
    }

    public ngOnDestroy() {
        document.removeEventListener('pointermove', this.moveHandler);
        document.removeEventListener('pointerup', this.upHandler);
        window.removeEventListener('resize', this.resizeHandler);
        this.videoLoadVersion += 1;
        this.stopLiveInference(true);
        this.destroyAiPosturePoseWorker();
        this.releaseVideoObjectUrl();
    }

    private emptyDraft() {
        return {
            decision: '', posture_class: '', abnormal_reasons: [], note: '',
            pose_keypoints: [], detector_polygon: null, detector_bbox: null,
            pose_model_id: '', pose_model_sha256: '', detector_model_id: '', detector_model_sha256: '',
            coordinate_corrected: false, coordinate_confirmed: false,
            automatic_judgement: null,
            judgement_corrected: false, judgement_touched: false,
            automatic_judgement_stale: false,
        };
    }

    public go(path: string) { this.service.href(path); }
    public reasons() { return ABNORMAL_CLASSES; }
    public postureClasses() { return POSTURE_CLASSES; }
    public decisionLabel(value: string) {
        return ({ NORMAL: '정상 자세', ABNORMAL: '비정상 자세', HOLD: '판단 보류' } as any)[value] || '미검수';
    }
    public postureClassLabel(value: string) {
        return POSTURE_CLASSES.find(row => row.key === value)?.short || this.decisionLabel(value);
    }
    public itemPostureLabel(item: any) {
        if (item?.decision === 'NORMAL') return this.postureClassLabel('NORMAL');
        const reasons = item?.abnormal_reasons || [];
        return reasons.length ? reasons.map((value: string) => this.postureClassLabel(value)).join(' · ') : this.decisionLabel(item?.decision);
    }

    private async callRuntime(action: string, payload: any = {}) {
        const form = payload instanceof FormData ? payload : new FormData();
        if (!(payload instanceof FormData)) {
            for (const [key, value] of Object.entries(payload || {})) {
                form.append(key, value == null ? '' : String(value));
            }
        }
        const response = await fetch(this.runtimeApi + action, {
            method: 'POST', body: form, credentials: 'same-origin',
        });
        const result = await response.json();
        return result || { code: response.status, data: {} };
    }

    public async load() {
        this.loading = true; this.errorMessage = ''; this.notice = '';
        await this.service.render();
        try {
            const { code, data } = await this.callRuntime('load', {
                status: this.statusFilter,
                decision: this.decisionFilter,
                review_mode: this.poseOnlyMode ? 'pose' : 'judgement',
                media_type: this.mediaFilter,
            });
            if (code !== 200) throw new Error(data?.message || '검수 목록을 불러오지 못했습니다.');
            this.summary = data?.summary || {};
            this.items = data?.items || [];
            const requestedIndex = this.requestedReviewItemId
                ? this.items.findIndex(item => item.image_id === this.requestedReviewItemId)
                : -1;
            if (requestedIndex >= 0) this.currentIndex = requestedIndex;
            this.currentIndex = Math.min(this.currentIndex, Math.max(0, this.items.length - 1));
            await this.openCurrent(false);
        } catch (error: any) {
            this.errorMessage = error?.message || '검수 목록을 불러오지 못했습니다.';
        }
        this.loading = false; await this.service.render();
    }

    public async applyFilters() { this.currentIndex = 0; await this.load(); }
    public async selectMedia(value: 'image' | 'video') {
        this.mediaFilter = value;
        this.currentIndex = 0;
        await this.load();
    }
    public async open(index: number) {
        this.currentIndex = Math.max(0, Math.min(this.items.length - 1, index));
        await this.openCurrent();
    }
    public async move(delta: number) { await this.open(this.currentIndex + delta); }

    private async fetchDetail(imageId: string) {
        if (this.detailCache.has(imageId)) return this.detailCache.get(imageId);
        if (this.detailRequests.has(imageId)) return this.detailRequests.get(imageId);
        const request = this.callRuntime('detail', {
            image_id: imageId,
            review_mode: this.poseOnlyMode ? 'pose' : 'judgement',
        }).then(({ code, data }) => {
            if (code !== 200) throw new Error(data?.message || '사진과 모델 좌표를 불러오지 못했습니다.');
            this.detailCache.set(imageId, data?.item);
            return data?.item;
        }).finally(() => this.detailRequests.delete(imageId));
        this.detailRequests.set(imageId, request);
        return request;
    }

    private prefetchNextDetail() {
        const next = this.items[this.currentIndex + 1];
        if (!next?.image_id) return;
        this.fetchDetail(next.image_id).catch(() => undefined);
    }

    private async openCurrent(render = true) {
        this.videoLoadVersion += 1;
        this.stopLiveInference(true);
        this.releaseVideoObjectUrl();
        this.reviewFramePoseSuggestion = [];
        this.poseSuggestionSource = '';
        const row = this.items[this.currentIndex];
        if (!row) {
            this.current = null; this.draft = this.emptyDraft();
            if (render) await this.service.render();
            return;
        }
        this.errorMessage = '';
        try {
            this.current = await this.fetchDetail(row.image_id);
            if (this.current?.image_id && this.current.image_id !== row.image_id) {
                this.items[this.currentIndex] = {
                    ...row,
                    image_id: this.current.image_id,
                    filename: this.current.filename,
                    source_video_sha256: this.current.source_video_sha256,
                    video_frame_index: this.current.video_frame_index,
                    video_frame_slot_id: this.current.video_frame_slot_id,
                    video_time_seconds: this.current.video_time_seconds,
                };
                this.detailCache.set(this.current.image_id, this.current);
            }
            const coordinates = this.current?.coordinate_draft || {};
            const automatic = this.current?.automatic_judgement || {};
            const postureClass = this.current?.posture_class || automatic.posture_class || '';
            const decision = this.current?.decision || automatic.decision || '';
            const automaticReasons = Array.isArray(automatic.abnormal_reasons)
                ? automatic.abnormal_reasons.filter((value: string, index: number, rows: string[]) =>
                    ABNORMAL_CLASSES.some(row => row.key === value) && rows.indexOf(value) === index)
                : [];
            this.draft = {
                decision,
                posture_class: postureClass,
                abnormal_reasons: this.current?.decision
                    ? [...(this.current?.abnormal_reasons || [])]
                    : (decision === 'ABNORMAL'
                        ? (automaticReasons.length ? automaticReasons : postureClass ? [postureClass] : [])
                        : []),
                note: this.current?.note || '',
                pose_keypoints: this.clone(coordinates.pose_keypoints || []),
                detector_polygon: this.clone(coordinates.detector_polygon || null),
                detector_bbox: this.clone(coordinates.detector_bbox || null),
                pose_model_id: coordinates.pose_model_id || this.current?.model_coordinates?.pose_model_id || '',
                pose_model_sha256: coordinates.pose_model_sha256 || this.current?.model_coordinates?.pose_model_sha256 || '',
                detector_model_id: coordinates.detector_model_id || this.current?.model_coordinates?.detector_model_id || '',
                detector_model_sha256: coordinates.detector_model_sha256 || this.current?.model_coordinates?.detector_model_sha256 || '',
                coordinate_corrected: Boolean(coordinates.coordinate_corrected),
                coordinate_confirmed: Boolean(coordinates.coordinate_confirmed),
                automatic_judgement: automatic,
                judgement_corrected: Boolean(this.current?.judgement_corrected),
                judgement_touched: Boolean(this.current?.decision),
                automatic_judgement_stale: false,
            };
            this.poseSuggestionSource = this.draft.pose_model_id === AI_POSTURE_POSE_MODEL_ID
                ? 'mediapipe_pose_33'
                : '';
            this.reviewFramePoseSuggestion = this.clone(
                this.current?.model_coordinates?.pose_keypoints || []
            );
            this.selectedPointId = 11;
            this.detectorCaptureMode = false;
            this.videoPlaying = false;
            this.videoPlaybackStarted = false;
            this.videoCurrentTime = 0;
            this.videoAtReviewFrame = !this.isVideo()
                || Math.abs(this.videoCurrentTime - this.reviewFrameTime()) <= .04;
            this.videoLoadError = false;
            this.videoPreparing = this.isVideo();
            this.videoFrameRetargeting = false;
            this.pendingVideoFrame = null;
            this.livePoseCorrectionApplied = false;
            this.videoDetectorLabels = this.clone(this.current?.video_detector_labels || []);
            this.resetSavedPoseSceneTracking();
            if (this.isVideo()) {
                await this.loadVideoPoseCorrections();
            } else {
                this.videoPoseCorrections = [];
                this.videoDetectorLabels = [];
            }
            this.zoomScale = 1;
            this.zoomMode = 'full';
            this.baseImageDisplay = { width: 0, height: 0 };
            setTimeout(() => this.updateBaseImageSize(true), 0);
            if (this.isVideo()) this.prepareVideoPlayback(this.videoLoadVersion);
            this.prefetchNextDetail();
        } catch (error: any) {
            this.errorMessage = error?.message || '사진과 모델 좌표를 불러오지 못했습니다.';
        }
        if (render) await this.service.render();
    }

    private clone(value: any) { return value == null ? value : JSON.parse(JSON.stringify(value)); }

    public imageUrl() {
        return this.current?.image_id
            ? this.runtimeApi + 'image?image_id=' + encodeURIComponent(this.current.image_id)
            : '';
    }

    public isVideo() { return this.current?.media_type === 'video_frame'; }
    public videoUrl() {
        return this.current?.image_id && this.isVideo()
            ? this.runtimeApi + 'image?image_id=' + encodeURIComponent('video:' + this.current.image_id)
            : '';
    }
    public videoPlaybackUrl() { return this.videoObjectUrl; }
    public reviewFrameTime() { return Number(this.current?.video_time_seconds || 0); }
    public videoPoseAnchorCount() { return this.poseCorrectionAnchors().length; }
    public videoDetectorLabelCount() { return (this.videoDetectorLabels || []).length; }
    private poseTrackingDiagnosticLabel() {
        const diagnostics = [];
        if (this.livePoseTrackingHeldCount) diagnostics.push(`가림 ${this.livePoseTrackingHeldCount}개 유지`);
        if (this.livePoseSwapCorrected) diagnostics.push('좌우 보정');
        if (this.livePoseSkeletonConstrainedCount) {
            diagnostics.push(`연결 ${this.livePoseSkeletonConstrainedCount}개 안정화`);
        }
        if (this.livePoseCorrectionGuarded) {
            diagnostics.push(`보정 드리프트 ${Math.round(this.livePoseCorrectionDrift * 100)}% 제한`);
        }
        if (this.livePoseSceneContinuation) diagnostics.push('동일 장면 연속 보정');
        return diagnostics.length ? ` · ${diagnostics.join(' · ')}` : '';
    }
    private async loadVideoPoseCorrections() {
        const sourceVideoSha256 = String(this.current?.source_video_sha256 || '');
        this.videoPoseCorrections = [];
        if (!sourceVideoSha256) return;
        try {
            const { code, data } = await this.callRuntime('pose_corrections', {
                source_video_sha256: sourceVideoSha256,
            });
            if (code !== 200) return;
            const result = data?.result || {};
            if (result?.matched !== true || !Array.isArray(result?.corrections)) return;
            this.videoPoseCorrections = result.corrections
                .filter((row: any) => Number.isFinite(Number(row?.video_time_seconds)))
                .sort((left: any, right: any) => (
                    Number(left.video_time_seconds) - Number(right.video_time_seconds)
                ));
        } catch (_) {
            this.videoPoseCorrections = [];
        }
    }
    public showCoordinateOverlay() {
        return !this.isVideo()
            || this.videoLoadError
            || this.hasJudgementVideoLabelTracks()
            || (!this.videoPlaying && this.videoAtReviewFrame);
    }
    public showVideoLiveOverlay() {
        return this.poseOnlyMode
            && this.isVideo()
            && !this.videoLoadError
            && (this.videoPlaying || !this.videoAtReviewFrame)
            && this.livePoseKeypoints.length > 0;
    }
    public shouldTrackReviewedPose() {
        return this.poseOnlyMode || this.hasJudgementVideoLabelTracks();
    }
    public showJudgementPoseTracking() {
        return this.hasJudgementVideoLabelTracks()
            && this.livePoseKeypoints.some(point => (
                AI_POSTURE_VIDEO_IDS.has(Number(point.id)) && this.isPoseVisible(point)
            ));
    }
    public liveOverlayPoseColor(kind: 'line' | 'point') {
        if (this.showJudgementPoseTracking()) {
            return kind === 'line' ? this.operatingPoseStyle.line : this.operatingPoseStyle.point;
        }
        if (!this.showVideoLiveOverlay()) {
            return kind === 'line' ? this.operatingPoseStyle.line : this.operatingPoseStyle.point;
        }
        return '#22c55e';
    }
    public canEditCoordinates() {
        return this.showCoordinateOverlay()
            && (!this.isVideo() || this.videoLoadError || (!this.videoPlaying && this.videoAtReviewFrame));
    }
    public hasJudgementVideoLabelTracks() {
        return !this.poseOnlyMode
            && this.isVideo()
            && this.usesExistingCoordinateLabels()
            && this.poseCorrectionAnchors().length > 0
            && this.videoDetectorLabelCount() > 0;
    }
    private surroundingVideoLabels(anchors: any[], sourceTime: number) {
        const ordered = [...anchors].filter((anchor: any) => (
            Number.isFinite(Number(anchor?.video_time_seconds ?? anchor?.time_seconds))
        )).sort((left: any, right: any) => (
            Number(left?.video_time_seconds ?? left?.time_seconds)
            - Number(right?.video_time_seconds ?? right?.time_seconds)
        ));
        if (!ordered.length) return null;
        const before = [...ordered].reverse().find((anchor: any) => (
            Number(anchor?.video_time_seconds ?? anchor?.time_seconds) <= sourceTime
        )) || ordered[0];
        const after = ordered.find((anchor: any) => (
            Number(anchor?.video_time_seconds ?? anchor?.time_seconds) >= sourceTime
        )) || ordered[ordered.length - 1];
        const beforeTime = Number(before?.video_time_seconds ?? before?.time_seconds);
        const afterTime = Number(after?.video_time_seconds ?? after?.time_seconds);
        const ratio = afterTime > beforeTime
            ? this.clamp((sourceTime - beforeTime) / (afterTime - beforeTime), 0, 1)
            : 0;
        return { before, after, ratio };
    }
    private judgementVideoPoseKeypoints() {
        const segment = this.surroundingVideoLabels(
            this.poseCorrectionAnchors(), this.videoCurrentTime,
        );
        if (!segment) return this.draft?.pose_keypoints || [];
        const before = this.posePointMap(segment.before.pose_keypoints);
        const after = this.posePointMap(segment.after.pose_keypoints);
        const ids = new Set<number>(AI_POSTURE_KEY_IDS.filter(id => before.has(id) || after.has(id)));
        return [...ids].map((id: number) => {
            const first = before.get(id) || after.get(id);
            const second = after.get(id) || before.get(id);
            return {
                ...this.clone(first),
                id,
                x: Number(first.x) + (Number(second.x) - Number(first.x)) * segment.ratio,
                y: Number(first.y) + (Number(second.y) - Number(first.y)) * segment.ratio,
                confidence: Number(first.confidence || 1)
                    + (Number(second.confidence || 1) - Number(first.confidence || 1)) * segment.ratio,
                visibility: 'visible',
            };
        });
    }
    private judgementVideoDetectorPolygon() {
        const segment = this.surroundingVideoLabels(
            this.videoDetectorLabels || [], this.videoCurrentTime,
        );
        if (!segment) return this.draft?.detector_polygon || null;
        const before = segment.before?.polygon || {};
        const after = segment.after?.polygon || before;
        const polygon: any = {};
        DETECTOR_CORNERS.forEach(name => {
            const first = before[name] || after[name];
            const second = after[name] || before[name];
            if (!first || !second) return;
            polygon[name] = {
                x: Number(first.x) + (Number(second.x) - Number(first.x)) * segment.ratio,
                y: Number(first.y) + (Number(second.y) - Number(first.y)) * segment.ratio,
            };
        });
        return polygon;
    }
    public overlayPosePoints() {
        if (this.canEditCoordinates()) return this.visiblePosePoints();
        if (this.showJudgementPoseTracking()) {
            return this.livePoseKeypoints.filter(point => (
                AI_POSTURE_VIDEO_IDS.has(Number(point.id)) && this.isPoseVisible(point)
            ));
        }
        if (this.hasJudgementVideoLabelTracks()) {
            return this.judgementVideoPoseKeypoints().filter(point => this.isPoseVisible(point));
        }
        return this.showVideoLiveOverlay()
            ? this.livePoseKeypoints.filter(point => this.isPoseVisible(point)
                && (!this.poseOnlyMode || AI_POSTURE_VIDEO_IDS.has(Number(point.id))))
            : this.visiblePosePoints();
    }
    public overlaySkeletonEdges() {
        const points = this.canEditCoordinates()
            ? this.draft?.pose_keypoints || []
            : this.showJudgementPoseTracking()
            ? this.livePoseKeypoints
            : this.hasJudgementVideoLabelTracks()
            ? this.judgementVideoPoseKeypoints()
            : this.showVideoLiveOverlay() ? this.livePoseKeypoints : this.draft?.pose_keypoints || [];
        return this.poseSkeletonEdges(points);
    }
    private poseSkeletonEdges(points: any[]) {
        const byId: any = {};
        points.forEach((point: any) => { byId[Number(point.id)] = point; });
        const connections = this.poseOnlyMode || this.usesExistingCoordinateLabels()
            ? AI_POSTURE_CONNECTIONS
            : XRAY_OPERATING_POSE_CONNECTIONS;
        return connections.map(([fromId, toId]) => ({
            from: byId[Number(fromId)], to: byId[Number(toId)],
        })).filter((edge: any) => this.isPoseVisible(edge.from) && this.isPoseVisible(edge.to));
    }
    public overlayDetectorPoints() {
        if (this.canEditCoordinates()) return this.detectorPoints();
        if (this.hasJudgementVideoLabelTracks()) {
            return this.detectorPoints(this.judgementVideoDetectorPolygon());
        }
        return this.showVideoLiveOverlay()
            ? this.detectorPoints(this.liveDetectorPolygon)
            : this.detectorPoints();
    }
    public overlayDetectorPolygonString() {
        return this.overlayDetectorPoints().map(point => `${Number(point.x)},${Number(point.y)}`).join(' ');
    }
    public liveInferenceStatus() {
        if (this.liveInferenceError) return this.liveInferenceError;
        if (!this.videoPlaying
            && this.pausedPoseRefinementSamples.length > 0
            && this.pausedPoseRefinementSamples.length < this.pausedPoseRefinementTarget) {
            return `현재 정지 화면 관절 정밀 분석 ${this.pausedPoseRefinementSamples.length}/${this.pausedPoseRefinementTarget}`;
        }
        if (!this.liveInferenceCount) return this.shouldTrackReviewedPose()
            ? '운영 자세 모델 첫 프레임 분석 중'
            : '실시간 Pose 첫 프레임 분석 중';
        const visible = AI_POSTURE_KEY_IDS.filter(pointId => this.isPoseVisible(
            this.livePoseKeypoints.find(point => Number(point.id) === pointId),
        )).length;
        const reviewedPoseTracking = this.shouldTrackReviewedPose();
        const prefix = reviewedPoseTracking ? '운영 자세 모델 추적' : '실시간 Pose';
        if (reviewedPoseTracking && this.livePoseCorrectionApplied) {
            return `저장 GT ${this.videoPoseAnchorCount()}개 기준 관절 추적 · 상체 ${visible}/6관절 · ${this.liveInferenceSourceTime.toFixed(1)}초${this.poseTrackingDiagnosticLabel()}`;
        }
        return reviewedPoseTracking
            ? `${prefix} 상체 ${visible}/6관절 · ${this.liveInferenceSourceTime.toFixed(1)}초${this.poseTrackingDiagnosticLabel()}`
            : `${prefix} ${this.livePoseKeypoints.filter(point => this.isPoseVisible(point)).length}/33관절 · ${this.liveInferenceSourceTime.toFixed(1)}초`;
    }
    public videoStatusLabel() {
        if (this.videoLoadError) return '동영상 재생 불가';
        if (this.videoPreparing) return '동영상 불러오는 중';
        if (this.videoPlaying) return '동영상 재생 중';
        if (this.videoAtReviewFrame) return `검수 프레임 ${this.reviewFrameTime().toFixed(1)}초`;
        return `현재 ${this.videoCurrentTime.toFixed(1)}초`;
    }

    private async prepareVideoPlayback(version: number) {
        try {
            const response = await fetch(this.videoUrl(), { credentials: 'same-origin' });
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            const source = await response.blob();
            if (version !== this.videoLoadVersion) return;
            const blob = source.type === 'video/mp4'
                ? source
                : new Blob([source], { type: 'video/mp4' });
            this.videoObjectUrl = URL.createObjectURL(blob);
            this.videoPreparing = false;
            this.videoLoadError = false;
            this.service.render();
        } catch (_) {
            if (version !== this.videoLoadVersion) return;
            this.videoPreparing = false;
            this.onVideoError();
        }
    }
    private releaseVideoObjectUrl() {
        if (!this.videoObjectUrl) return;
        URL.revokeObjectURL(this.videoObjectUrl);
        this.videoObjectUrl = '';
    }

    public onVideoLoadedMetadata(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.resetSavedPoseSceneTracking();
        this.videoPlaybackStarted = false;
        video.currentTime = 0;
        video.pause();
        this.videoPlaying = false;
        this.videoLoadError = false;
        this.syncVideoPosition(video);
        setTimeout(() => this.updateBaseImageSize(true), 0);
    }
    public onVideoLoadedData(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.syncVideoPosition(video);
        this.updateBaseImageSize(true);
    }
    public onVideoSeeked(event: Event) {
        const video = event.target as HTMLVideoElement;
        if (Math.abs(Number(video.currentTime || 0) - this.liveInferenceSourceTime) > .25) {
            this.aiPosturePointStates.clear();
            this.aiPostureMedianWindows.clear();
            this.previousStablePoseKeypoints = [];
            this.livePoseKeypoints = [];
            this.liveInferenceCount = 0;
            this.resetSavedPoseSceneTracking();
        }
        this.syncVideoPosition(video);
        this.updateBaseImageSize(true);
        if (this.shouldTrackReviewedPose() && !this.videoPlaying && this.videoPlaybackStarted) {
            this.beginPausedPoseRefinement(video);
            this.inferPausedVideoFrame(video);
        }
    }
    public onVideoPlay(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.resetPausedPoseRefinement();
        this.videoPlaybackStarted = true;
        this.videoPlaying = true;
        this.videoAtReviewFrame = false;
        this.detectorCaptureMode = false;
        this.endDrag();
        this.videoCurrentTime = Number(video.currentTime || 0);
        if (this.shouldTrackReviewedPose()) this.startLiveInference(video);
        this.service.render();
    }
    public onVideoPause(event: Event) {
        const video = event.target as HTMLVideoElement;
        const playbackStarted = this.videoPlaybackStarted;
        this.videoPlaying = false;
        this.stopLiveInference(false);
        this.syncVideoPosition(video);
        if (this.shouldTrackReviewedPose() && !this.videoAtReviewFrame && playbackStarted && !video.ended) {
            this.beginPausedPoseRefinement(video);
            this.inferPausedVideoFrame(video);
        }
    }
    public onVideoTimeUpdate(event: Event) {
        const video = event.target as HTMLVideoElement;
        this.videoCurrentTime = Number(video.currentTime || 0);
        if (this.hasJudgementVideoLabelTracks()) this.service.render();
    }
    public onVideoError() {
        this.stopLiveInference(true);
        this.videoLoadError = true;
        this.videoPreparing = false;
        this.videoPlaying = false;
        this.videoAtReviewFrame = false;
        this.errorMessage = '원본 동영상을 재생하지 못했습니다. 대표 프레임으로 좌표 검수는 계속할 수 있습니다.';
        this.service.render();
    }
    public returnToReviewFrame() {
        const video = document.getElementById('normality-review-media') as HTMLVideoElement;
        if (!video || video.tagName !== 'VIDEO') return;
        this.stopLiveInference(true);
        this.videoPlaybackStarted = false;
        video.pause();
        video.currentTime = this.reviewFrameTime();
        this.videoPlaying = false;
        this.syncVideoPosition(video);
    }
    public currentFrameEditReady() {
        if (!this.poseOnlyMode || !this.isVideo() || this.videoPlaying || this.videoAtReviewFrame) return false;
        const fps = Math.max(1, Number(this.current?.video_fps || 30));
        const inferenceMatches = Math.abs(this.liveInferenceSourceTime - this.videoCurrentTime) <= Math.max(.08, 1.5 / fps);
        return inferenceMatches && AI_POSTURE_KEY_IDS.every(id => {
            const point = this.livePoseKeypoints.find(item => Number(item.id) === id);
            return Boolean(point) && Number.isFinite(Number(point.x)) && Number.isFinite(Number(point.y));
        });
    }
    private capturePausedVideoFrame(video: HTMLVideoElement) {
        return new Promise<Blob | null>(resolve => {
            if (!video.videoWidth || !video.videoHeight) return resolve(null);
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return resolve(null);
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            canvas.toBlob(resolve, 'image/jpeg', .92);
        });
    }
    private async inferOperatingPoseFrame(frame: Blob) {
        const form = new FormData();
        form.append('image', frame, 'pose-review-frame.jpg');
        form.append('analysis_backend', 'yolo_candidate');
        form.append('realtime', 'true');
        const response = await fetch('/wiz/api/page.xray/analyze_v2', {
            method: 'POST', body: form, credentials: 'same-origin',
        });
        const payload = await response.json();
        const data = payload?.data || {};
        const landmarks = Array.isArray(data?.landmarks) ? data.landmarks : [];
        if (
            Number(payload?.code || response.status) !== 200
            || data?.trained_pose_model_applied !== true
            || data?.trained_pose_model_executed !== true
            || landmarks.length !== 33
        ) {
            throw new Error('현재 운영 자세 모델로 관절을 찾지 못했습니다. 잠시 후 다시 시도해 주세요.');
        }
        const existing = new Map<number, any>(
            (this.current?.model_coordinates?.pose_keypoints || [])
                .map((point: any) => [Number(point.id), point])
        );
        return {
            keypoints: landmarks.map((point: any, index: number) => {
                const id = Number(point?.id ?? index);
                const confidence = this.clamp(
                    Number(point?.visibility ?? point?.confidence ?? 0), 0, 1
                );
                return {
                    id,
                    name: existing.get(id)?.name || `keypoint_${id}`,
                    x: this.clamp(Number(point?.x), 0, 1),
                    y: this.clamp(Number(point?.y), 0, 1),
                    confidence,
                    source_confidence: confidence,
                    visibility: confidence >= .2 ? 'visible' : 'not_labeled',
                };
            }),
            modelId: String(data?.active_pose_model_id || ''),
            modelSha256: String(data?.active_pose_weight_sha256 || ''),
        };
    }
    public async editCurrentVideoFrame() {
        if (!this.currentFrameEditReady() || this.videoFrameRetargeting) return;
        const video = document.getElementById('normality-review-media') as HTMLVideoElement;
        if (!video || video.tagName !== 'VIDEO' || !video.paused) return;
        this.videoFrameRetargeting = true;
        this.errorMessage = '';
        this.notice = '';
        await this.service.render();
        try {
            const frame = await this.capturePausedVideoFrame(video);
            if (!frame) throw new Error('현재 동영상 화면을 관절 수정 프레임으로 준비하지 못했습니다.');
            const operatingPose = await this.inferOperatingPoseFrame(frame);
            this.videoCurrentTime = Number(video.currentTime || this.videoCurrentTime);
            const poseReference = this.clone(operatingPose.keypoints);
            const pose = this.applySavedPoseCorrection(
                this.clone(poseReference), this.videoCurrentTime, operatingPose.modelId,
            );
            this.pendingVideoFrame = {
                blob: frame,
                imageId: String(this.current?.image_id || ''),
                timeSeconds: this.videoCurrentTime,
                sourceVideoSha256: this.current?.source_video_sha256 || '',
                videoFrameIndex: this.current?.video_frame_index ?? '',
                videoFrameSlotId: this.current?.video_frame_slot_id || '',
                poseReferenceKeypoints: poseReference,
            };
            this.draft.pose_keypoints = pose;
            this.draft.pose_model_id = operatingPose.modelId;
            this.draft.pose_model_sha256 = operatingPose.modelSha256;
            this.draft.coordinate_corrected = false;
            this.draft.coordinate_confirmed = false;
            this.reviewFramePoseSuggestion = this.clone(poseReference);
            this.poseSuggestionSource = '';
            this.videoAtReviewFrame = true;
            this.notice = `현재 ${this.videoCurrentTime.toFixed(1)}초 화면을 운영 자세 모델로 다시 분석했습니다. 관절을 바로 수정할 수 있습니다.`;
        } catch (error: any) {
            this.errorMessage = error?.message || '현재 동영상 화면을 관절 수정 상태로 준비하지 못했습니다.';
        }
        this.videoFrameRetargeting = false;
        await this.service.render();
    }
    private startLiveInference(video: HTMLVideoElement) {
        this.stopLiveInference(false);
        const generation = this.liveInferenceGeneration;
        this.liveInferenceActive = true;
        this.liveInferenceError = '';
        const tick = async () => {
            if (!this.liveInferenceActive || generation !== this.liveInferenceGeneration) return;
            await this.inferLiveVideoFrame(video, generation);
            if (!this.liveInferenceActive || generation !== this.liveInferenceGeneration) return;
            this.liveInferenceTimer = setTimeout(tick, this.liveInferenceDelayMs);
        };
        void tick();
    }
    private stopLiveInference(clear: boolean) {
        this.liveInferenceGeneration += 1;
        if (this.liveInferenceTimer) clearTimeout(this.liveInferenceTimer);
        this.liveInferenceTimer = null;
        this.liveInferenceActive = false;
        this.liveInferenceBusy = false;
        if (!clear) return;
        this.livePoseKeypoints = [];
        this.liveDetectorPolygon = null;
        this.liveInferenceError = '';
        this.liveInferenceCount = 0;
        this.liveInferenceSourceTime = 0;
        this.livePoseBackend = '';
        this.livePoseCorrectionApplied = false;
        this.aiPostureFrameContext = null;
        this.aiPosturePointStates.clear();
        this.aiPostureMedianWindows.clear();
        this.previousStablePoseKeypoints = [];
        this.livePoseTrackingHeldCount = 0;
        this.livePoseSwapCorrected = false;
        this.livePoseSkeletonConstrainedCount = 0;
        this.livePoseCorrectionDrift = 0;
        this.livePoseCorrectionGuarded = false;
        this.resetSavedPoseSceneTracking();
        this.resetPausedPoseRefinement();
    }
    private resetPausedPoseRefinement(sourceTime = -1) {
        if (this.pausedPoseRefinementTimer) clearTimeout(this.pausedPoseRefinementTimer);
        this.pausedPoseRefinementTimer = null;
        this.pausedPoseRefinementTime = sourceTime;
        this.pausedPoseRefinementSamples = [];
    }
    private beginPausedPoseRefinement(video: HTMLVideoElement) {
        const sourceTime = Number(video.currentTime || 0);
        const fps = Math.max(1, Number(this.current?.video_fps || 30));
        const tolerance = Math.max(.04, .55 / fps);
        if (Math.abs(this.pausedPoseRefinementTime - sourceTime) <= tolerance
            && this.pausedPoseRefinementSamples.length > 0) return;
        this.resetPausedPoseRefinement(sourceTime);
        this.aiPosturePointStates.clear();
        this.aiPostureMedianWindows.clear();
        this.previousStablePoseKeypoints = [];
        this.livePoseKeypoints = [];
        this.liveInferenceCount = 0;
        this.liveInferenceError = '';
    }
    private inferPausedVideoFrame(video: HTMLVideoElement) {
        this.beginPausedPoseRefinement(video);
        const generation = this.liveInferenceGeneration;
        void this.inferLiveVideoFrame(video, generation);
    }
    private async inferLiveVideoFrame(video: HTMLVideoElement, generation: number) {
        await this.inferOperatingVideoFrame(video, generation);
    }
    private async inferOperatingVideoFrame(video: HTMLVideoElement, generation: number) {
        if (this.liveInferenceBusy || video.readyState < 2 || !video.videoWidth) return;
        const canvas = document.getElementById('normality-live-frame-canvas') as HTMLCanvasElement;
        if (!canvas) return;
        const scale = Math.min(1, this.liveCaptureMaxWidth / video.videoWidth);
        canvas.width = Math.max(1, Math.round(video.videoWidth * scale));
        canvas.height = Math.max(1, Math.round(video.videoHeight * scale));
        const context = canvas.getContext('2d');
        if (!context) return;
        const sourceTime = Number(video.currentTime || 0);
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
        const jpegQuality = this.poseOnlyMode ? .86 : .85;
        const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(
            resolve, 'image/jpeg', jpegQuality,
        ));
        if (!blob || generation !== this.liveInferenceGeneration) return;
        this.liveInferenceBusy = true;
        try {
            const trackReviewedPose = this.shouldTrackReviewedPose();
            const form = new FormData();
            form.append('image', blob, 'video-frame.jpg');
            form.append('realtime', '1');
            form.append('tracking_id', this.liveTrackingId);
            if (trackReviewedPose) form.append('analysis_backend', 'yolo_candidate');
            const response = await fetch('/wiz/api/page.xray/analyze_v2', {
                method: 'POST', body: form, credentials: 'same-origin',
            });
            const payload = await response.json();
            if (generation !== this.liveInferenceGeneration) return;
            const data = payload?.data || {};
            const landmarks = Array.isArray(data.landmarks)
                ? data.landmarks
                : Array.isArray(data?.pose?.keypoints) ? data.pose.keypoints : [];
            if (Number(payload?.code || response.status) !== 200
                || (trackReviewedPose && (
                    data?.trained_pose_model_applied !== true
                    || data?.trained_pose_model_executed !== true
                    || landmarks.length !== 33
                ))) {
                throw new Error('현재 운영 자세 모델로 재생 프레임 관절을 찾지 못했습니다.');
            }
            const operatingPoints = landmarks.map((point: any, index: number) => {
                const confidence = Number(point?.confidence ?? point?.visibility ?? 0);
                return {
                    id: Number(point?.id ?? index),
                    x: Number(point?.x), y: Number(point?.y), confidence,
                    source_confidence: confidence,
                    visibility: confidence >= .20 ? 'visible' : 'not_labeled',
                };
            });
            const operatingPoseModelId = String(
                data?.active_pose_model_id || data?.pose_input_backend || '',
            );
            const stableOperatingPoints = trackReviewedPose
                ? this.stabilizeOperatingPosePoints(operatingPoints, performance.now())
                : operatingPoints;
            const correctedPoints = trackReviewedPose
                ? this.applySavedPoseCorrection(
                    stableOperatingPoints, sourceTime, operatingPoseModelId,
                )
                : stableOperatingPoints;
            this.livePoseKeypoints = correctedPoints;
            this.livePoseBackend = trackReviewedPose
                ? operatingPoseModelId || '운영 자세 모델'
                : String(data?.pose_input_backend || '운영 분석 모델');
            const detector = data?.bucky_detection || data?.bucky || {};
            const corners = detector?.corners || detector?.detector_config?.corners || null;
            this.liveDetectorPolygon = !trackReviewedPose && corners && DETECTOR_CORNERS.every(name => corners[name])
                ? this.clone(corners) : null;
            this.liveInferenceSourceTime = sourceTime;
            this.liveInferenceCount += 1;
            this.liveInferenceError = this.livePoseKeypoints.some(point => this.isPoseVisible(point))
                ? '' : trackReviewedPose
                    ? '현재 프레임 운영 자세 모델 미검출 · 재시도 중'
                    : '현재 프레임 Pose 미검출 · 재시도 중';
            this.service.render();
            if (this.poseOnlyMode && video.paused) this.autoEditPausedVideoFrame();
        } catch (_) {
            if (generation === this.liveInferenceGeneration) {
                this.liveInferenceError = this.shouldTrackReviewedPose()
                    ? '운영 자세 모델 재생 프레임 분석 재시도 중'
                    : '실시간 Pose 추론 재시도 중';
                this.service.render();
            }
        } finally {
            if (generation === this.liveInferenceGeneration) this.liveInferenceBusy = false;
        }
    }
    private autoEditPausedVideoFrame() {
        if (!this.currentFrameEditReady() || this.videoFrameRetargeting) return;
        void this.editCurrentVideoFrame();
    }
    private async ensureAiPosturePoseWorker(): Promise<void> {
        if (this.aiPosturePoseWorker && this.aiPosturePoseWorkerReady) return;
        if (this.aiPosturePoseWorkerReadyPromise) return this.aiPosturePoseWorkerReadyPromise;
        this.aiPosturePoseWorkerReadyPromise = new Promise<void>((resolve, reject) => {
            const worker = new Worker('/assets/temporal-pose.worker.js?v=20260819-shoulder-stability-v1');
            this.aiPosturePoseWorker = worker;
            let settled = false;
            const finish = (error?: Error) => {
                if (settled) return;
                settled = true;
                window.clearTimeout(timeoutHandle);
                if (error) {
                    worker.terminate();
                    if (this.aiPosturePoseWorker === worker) {
                        this.aiPosturePoseWorker = null;
                        this.aiPosturePoseWorkerReady = false;
                    }
                    reject(error);
                } else resolve();
            };
            const timeoutHandle = window.setTimeout(() => {
                finish(new Error('AI 자세판정 관절 모델 초기화 시간이 초과되었습니다.'));
            }, this.aiPostureWorkerInitTimeoutMs);
            worker.onmessage = (event: MessageEvent) => {
                const message = event.data || {};
                if (message.type === 'initializing') {
                    this.livePoseBackend = message.backend || 'MediaPipe Pose Landmarker · 초기화 중';
                    this.service.render();
                    return;
                }
                if (message.type === 'ready') {
                    this.aiPosturePoseWorkerReady = true;
                    this.aiPosturePoseAccelerated = message.accelerated === true;
                    this.livePoseBackend = message.backend || 'MediaPipe Pose Landmarker';
                    finish();
                    return;
                }
                if (message.type === 'result') {
                    this.liveInferenceBusy = false;
                    if (message.generation !== this.liveInferenceGeneration) return;
                    this.consumeAiPosturePoseResult(message);
                    return;
                }
                if (message.type === 'frame_error') {
                    this.liveInferenceBusy = false;
                    if (message.generation === this.liveInferenceGeneration) {
                        this.liveInferenceError = 'AI 자세판정 Pose 재시도 중';
                        this.service.render();
                    }
                    return;
                }
                if (message.type === 'error') {
                    finish(new Error(message.message || 'MediaPipe worker initialization failed'));
                }
            };
            worker.onerror = (event: ErrorEvent) => {
                this.liveInferenceBusy = false;
                finish(new Error(event.message || 'MediaPipe worker failed'));
            };
            this.aiPosturePoseAccelerated = this.hardwareWebGlAvailable();
            worker.postMessage({
                type: 'initialize',
                generation: this.liveInferenceGeneration,
                prefer_gpu: this.aiPosturePoseAccelerated,
            });
        }).finally(() => {
            this.aiPosturePoseWorkerReadyPromise = null;
        });
        return this.aiPosturePoseWorkerReadyPromise;
    }
    private hardwareWebGlAvailable() {
        try {
            if (navigator.webdriver || /HeadlessChrome/i.test(navigator.userAgent)) return false;
            const canvas = document.createElement('canvas');
            const gl = canvas.getContext('webgl2') || canvas.getContext('webgl');
            if (!gl) return false;
            const extension = gl.getExtension('WEBGL_debug_renderer_info');
            if (!extension) return false;
            const renderer = String(gl.getParameter(extension.UNMASKED_RENDERER_WEBGL) || '');
            return Boolean(renderer) && !/swiftshader|software|llvmpipe/i.test(renderer);
        } catch (_) {
            return false;
        }
    }
    private destroyAiPosturePoseWorker() {
        this.aiPosturePoseWorker?.terminate();
        this.aiPosturePoseWorker = null;
        this.aiPosturePoseWorkerReady = false;
        this.aiPosturePoseWorkerReadyPromise = null;
        this.aiPostureFrameContext = null;
        this.aiPosturePointStates.clear();
        this.aiPostureMedianWindows.clear();
    }
    private async inferAiPostureVideoFrame(video: HTMLVideoElement, generation: number) {
        if (this.liveInferenceBusy || video.readyState < 2 || !video.videoWidth) return;
        this.liveInferenceBusy = true;
        try {
            await this.ensureAiPosturePoseWorker();
            if (generation !== this.liveInferenceGeneration || !this.aiPosturePoseWorker) return;
            const canvas = document.getElementById('normality-live-frame-canvas') as HTMLCanvasElement;
            if (!canvas) return;
            const inputWidth = this.aiPosturePoseAccelerated ? 640 : 416;
            const inputHeight = inputWidth;
            const inputScale = Math.min(inputWidth / video.videoWidth, inputHeight / video.videoHeight);
            const drawWidth = Math.max(1, Math.round(video.videoWidth * inputScale));
            const drawHeight = Math.max(1, Math.round(video.videoHeight * inputScale));
            const offsetX = Math.round((inputWidth - drawWidth) / 2);
            const offsetY = Math.round((inputHeight - drawHeight) / 2);
            canvas.width = inputWidth;
            canvas.height = inputHeight;
            const context = canvas.getContext('2d', { willReadFrequently: true });
            if (!context) return;
            context.fillStyle = '#000';
            context.fillRect(0, 0, inputWidth, inputHeight);
            context.drawImage(video, offsetX, offsetY, drawWidth, drawHeight);
            const sourceTime = Number(video.currentTime || 0);
            const fps = Math.max(1, Number(this.current?.video_fps || 30));
            const isReviewFrame = Math.abs(sourceTime - this.reviewFrameTime()) <= Math.max(.04, .55 / fps);
            const timestamp = Math.max(this.aiPosturePoseTimestamp + 1, Math.round(performance.now()));
            this.aiPosturePoseTimestamp = timestamp;
            this.aiPostureFrameContext = { generation, sourceTime, isReviewFrame };
            const imageData = context.getImageData(0, 0, inputWidth, inputHeight);
            this.aiPosturePoseWorker.postMessage({
                type: 'frame', generation, timestamp, image_data: imageData,
                transform: { inputWidth, inputHeight, drawWidth, drawHeight, offsetX, offsetY },
            }, [imageData.data.buffer]);
        } catch (_) {
            if (generation === this.liveInferenceGeneration) {
                this.liveInferenceError = 'AI 자세판정 Pose를 불러오지 못해 운영 YOLO 좌표를 유지합니다.';
                this.service.render();
            }
        } finally {
            if (!this.aiPostureFrameContext || generation !== this.liveInferenceGeneration) {
                this.liveInferenceBusy = false;
            }
        }
    }
    private consumeAiPosturePoseResult(message: any) {
        const source = Array.isArray(message?.landmarks) ? message.landmarks : [];
        const frame = this.aiPostureFrameContext;
        this.aiPostureFrameContext = null;
        if (!frame || source.length !== 33) {
            this.liveInferenceError = '현재 프레임 AI 자세판정 Pose 미검출 · 재시도 중';
            this.service.render();
            return;
        }
        const transform = message?.transform || {};
        const normalized = source.map((point: any) => ({
            ...point,
            x: (Number(point.x) * Number(transform.inputWidth) - Number(transform.offsetX)) / Number(transform.drawWidth),
            y: (Number(point.y) * Number(transform.inputHeight) - Number(transform.offsetY)) / Number(transform.drawHeight),
        }));
        const filteredPoints = normalized.map((point: any, id: number) => this.filterAiPosturePoint(
            point, id, Number(message.timestamp),
        ));
        const savedCoordinates = this.current?.coordinate_draft || {};
        if (frame.isReviewFrame
            && (savedCoordinates.pose_reviewed === true || savedCoordinates.pose_draft === true)
            && (!Array.isArray(savedCoordinates.pose_reference_keypoints)
                || savedCoordinates.pose_reference_keypoints.length !== 33)) {
            savedCoordinates.pose_reference_keypoints = this.clone(filteredPoints);
        }
        let points = this.applySavedPoseCorrection(filteredPoints, Number(frame.sourceTime || 0));
        const video = document.getElementById('normality-review-media') as HTMLVideoElement;
        const fps = Math.max(1, Number(this.current?.video_fps || 30));
        const pausedTolerance = Math.max(.04, .55 / fps);
        const pausedAtSourceFrame = Boolean(video && video.paused
            && Math.abs(Number(video.currentTime || 0) - Number(frame.sourceTime || 0)) <= pausedTolerance);
        if (pausedAtSourceFrame) {
            if (Math.abs(this.pausedPoseRefinementTime - Number(frame.sourceTime || 0)) > pausedTolerance) {
                this.resetPausedPoseRefinement(Number(frame.sourceTime || 0));
            }
            this.pausedPoseRefinementSamples.push(this.clone(points));
            if (this.pausedPoseRefinementSamples.length >= this.pausedPoseRefinementTarget) {
                points = this.refinedPausedPosePoints(this.pausedPoseRefinementSamples);
            }
        }
        this.livePoseKeypoints = points;
        this.liveDetectorPolygon = null;
        this.liveInferenceSourceTime = Number(frame.sourceTime || 0);
        this.liveInferenceCount += 1;
        this.liveInferenceError = points.some(point => this.isPoseVisible(point))
            ? '' : '현재 프레임 AI 자세판정 Pose 미검출 · 재시도 중';
        if (pausedAtSourceFrame
            && this.pausedPoseRefinementSamples.length < this.pausedPoseRefinementTarget) {
            this.service.render();
            this.pausedPoseRefinementTimer = setTimeout(() => {
                if (video?.paused
                    && Math.abs(Number(video.currentTime || 0) - Number(frame.sourceTime || 0)) <= pausedTolerance) {
                    this.inferPausedVideoFrame(video);
                }
            }, 40);
            return;
        }
        this.service.render();
        this.autoEditPausedVideoFrame();
    }
    private refinedPausedPosePoints(samples: any[][]) {
        const latest = samples[samples.length - 1] || [];
        const median = (values: number[]) => {
            const sorted = values.filter(Number.isFinite).sort((left, right) => left - right);
            if (!sorted.length) return NaN;
            const middle = Math.floor(sorted.length / 2);
            return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
        };
        return latest.map((point: any, index: number) => {
            const id = Number(point?.id ?? index);
            const matching = samples.map(rows => rows.find(row => Number(row?.id) === id)).filter(Boolean);
            const x = median(matching.map(row => Number(row.x)));
            const y = median(matching.map(row => Number(row.y)));
            return Number.isFinite(x) && Number.isFinite(y) ? { ...point, id, x, y } : point;
        });
    }
    private stabilizeOperatingPosePoints(points: any[], timestamp: number) {
        const assigned = this.repairOperatingPoseLeftRight(points);
        const filtered = assigned.map((point: any, index: number) => (
            this.filterAiPosturePoint(point, Number(point?.id ?? index), timestamp)
        ));
        this.livePoseTrackingHeldCount = AI_POSTURE_KEY_IDS.filter(id => (
            filtered.find((point: any) => Number(point.id) === id)?.held === true
        )).length;
        const constrained = this.constrainOperatingPoseSkeleton(filtered);
        this.previousStablePoseKeypoints = this.clone(constrained);
        return constrained;
    }
    private poseDistance(left: any, right: any) {
        if (!left || !right) return Number.POSITIVE_INFINITY;
        return Math.hypot(Number(left.x) - Number(right.x), Number(left.y) - Number(right.y));
    }
    private repairOperatingPoseLeftRight(points: any[]) {
        this.livePoseSwapCorrected = false;
        const previous = this.posePointMap(this.previousStablePoseKeypoints);
        if (!AI_POSTURE_KEY_IDS.every(id => previous.has(id))) return points;
        const current = this.posePointMap(points);
        const pairs = [[11, 12], [13, 14], [23, 24]];
        const directCost = pairs.reduce((sum, [leftId, rightId]) => (
            sum
            + this.poseDistance(current.get(leftId), previous.get(leftId))
            + this.poseDistance(current.get(rightId), previous.get(rightId))
        ), 0);
        const swappedCost = pairs.reduce((sum, [leftId, rightId]) => (
            sum
            + this.poseDistance(current.get(leftId), previous.get(rightId))
            + this.poseDistance(current.get(rightId), previous.get(leftId))
        ), 0);
        if (!Number.isFinite(directCost) || swappedCost + .06 >= directCost) return points;
        this.livePoseSwapCorrected = true;
        const swappedById = new Map<number, any>();
        pairs.forEach(([leftId, rightId]) => {
            const left = current.get(leftId);
            const right = current.get(rightId);
            swappedById.set(leftId, { ...right, id: leftId, left_right_reassigned: true });
            swappedById.set(rightId, { ...left, id: rightId, left_right_reassigned: true });
        });
        return points.map((point: any) => swappedById.get(Number(point.id)) || point);
    }
    private constrainOperatingPoseSkeleton(points: any[]) {
        this.livePoseSkeletonConstrainedCount = 0;
        const previous = this.posePointMap(this.previousStablePoseKeypoints);
        if (!previous.size) return points;
        const current = this.posePointMap(points);
        const connections = [[11, 13], [12, 14], [11, 23], [12, 24]];
        connections.forEach(([rootId, childId]) => {
            const root = current.get(rootId);
            const child = current.get(childId);
            const previousRoot = previous.get(rootId);
            const previousChild = previous.get(childId);
            if (![root, child, previousRoot, previousChild].every(value => this.isPoseVisible(value))) return;
            const previousLength = this.poseDistance(previousRoot, previousChild);
            const currentLength = this.poseDistance(root, child);
            if (!Number.isFinite(previousLength) || previousLength < .015 || !Number.isFinite(currentLength)) return;
            const minimum = previousLength * .55;
            const maximum = previousLength * 1.65;
            if (currentLength >= minimum && currentLength <= maximum) return;
            const targetLength = this.clamp(currentLength, minimum, maximum);
            const directionX = currentLength > .0001
                ? (Number(child.x) - Number(root.x)) / currentLength
                : (Number(previousChild.x) - Number(previousRoot.x)) / previousLength;
            const directionY = currentLength > .0001
                ? (Number(child.y) - Number(root.y)) / currentLength
                : (Number(previousChild.y) - Number(previousRoot.y)) / previousLength;
            current.set(childId, {
                ...child,
                x: this.clamp(Number(root.x) + directionX * targetLength, 0, 1),
                y: this.clamp(Number(root.y) + directionY * targetLength, 0, 1),
                skeleton_constrained: true,
            });
            this.livePoseSkeletonConstrainedCount += 1;
        });
        return points.map((point: any) => current.get(Number(point.id)) || point);
    }
    private applySavedPoseCorrection(
        points: any[], sourceTime: number, sourceModelId = '',
    ) {
        this.livePoseCorrectionApplied = false;
        this.livePoseCorrectionDrift = 0;
        this.livePoseCorrectionGuarded = false;
        this.livePoseSceneContinuation = false;
        const savedAnchorHoldSeconds = .3;
        const savedAnchorFadeSeconds = .75;
        const savedSkeletonGuideHoldSeconds = .35;
        const savedSkeletonGuideFadeSeconds = .65;
        const legacyRadiusSeconds = .5;
        const anchors = this.poseCorrectionAnchors();
        if (!this.shouldTrackReviewedPose() || !anchors.length) {
            this.resetSavedPoseSceneTracking();
            return points;
        }
        const compatible = anchors.filter((anchor: any) => {
            const modelId = String(anchor.pose_model_id || '');
            if (this.poseOnlyMode && sourceModelId && modelId && sourceModelId !== modelId) return false;
            const saved = this.posePointMap(anchor.pose_keypoints);
            const reference = this.posePointMap(anchor.pose_reference_keypoints);
            return AI_POSTURE_KEY_IDS.every(id => (
                this.isPoseVisible(saved.get(id)) && this.isPoseVisible(reference.get(id))
            ));
        });
        if (compatible.length) {
            const firstTime = Number(compatible[0].video_time_seconds);
            const lastTime = Number(compatible[compatible.length - 1].video_time_seconds);
            const before = [...compatible].reverse().find(
                (anchor: any) => Number(anchor.video_time_seconds) <= sourceTime,
            ) || compatible[0];
            const after = compatible.find(
                (anchor: any) => Number(anchor.video_time_seconds) >= sourceTime,
            ) || compatible[compatible.length - 1];
            const beforeTime = Number(before.video_time_seconds);
            const afterTime = Number(after.video_time_seconds);
            const interpolation = afterTime > beforeTime
                ? this.clamp((sourceTime - beforeTime) / (afterTime - beforeTime), 0, 1)
                : 0;
            const beforeSaved = this.posePointMap(before.pose_keypoints);
            const beforeReference = this.posePointMap(before.pose_reference_keypoints);
            const afterSaved = this.posePointMap(after.pose_keypoints);
            const afterReference = this.posePointMap(after.pose_reference_keypoints);
            const guidedBySavedSkeleton = this.poseAnchorGuidedPointMap(
                points, beforeSaved, beforeReference, afterSaved, afterReference, interpolation,
            );
            const nearest = Math.abs(sourceTime - beforeTime) <= Math.abs(sourceTime - afterTime)
                ? before : after;
            const nearestDistance = Math.abs(sourceTime - Number(nearest.video_time_seconds));
            const nearestSaved = this.posePointMap(nearest.pose_keypoints);
            const fps = Math.max(1, Number(this.current?.video_fps || 30));
            const exactAnchorTolerance = Math.max(.04, .55 / fps);
            const exactAnchorMatch = nearestDistance <= exactAnchorTolerance;
            const proposed = new Map<number, any>();
            points.forEach((point: any) => {
                const id = Number(point.id);
                const beforePoint = beforeSaved.get(id);
                const beforeBase = beforeReference.get(id);
                const afterPoint = afterSaved.get(id);
                const afterBase = afterReference.get(id);
                if (!AI_POSTURE_KEY_IDS.includes(id)
                    || ![beforePoint, beforeBase, afterPoint, afterBase].every(value => this.isPoseVisible(value))) return;
                const offsetX = (Number(beforePoint.x) - Number(beforeBase.x)) * (1 - interpolation)
                    + (Number(afterPoint.x) - Number(afterBase.x)) * interpolation;
                const offsetY = (Number(beforePoint.y) - Number(beforeBase.y)) * (1 - interpolation)
                    + (Number(afterPoint.y) - Number(afterBase.y)) * interpolation;
                proposed.set(id, {
                    ...point,
                    x: this.clamp(Number(point.x) + offsetX, 0, 1),
                    y: this.clamp(Number(point.y) + offsetY, 0, 1),
                });
            });
            const drift = this.poseCorrectionSkeletonDrift(points, proposed);
            const betweenAnchors = compatible.length > 1
                && sourceTime >= firstTime && sourceTime <= lastTime;
            const atOrAfterFirstAnchor = sourceTime + exactAnchorTolerance >= firstTime;
            const localSegmentWeight = atOrAfterFirstAnchor
                ? betweenAnchors ? 1 : this.clamp(
                    1 - (
                        Math.max(0, nearestDistance - savedAnchorHoldSeconds)
                        / savedAnchorFadeSeconds
                    ), 0, 1,
                ) : 0;
            const sceneContinuation = this.poseOnlyMode
                ? this.continueSavedPoseCorrectionThroughScene(
                    points, sourceTime, localSegmentWeight > .01,
                )
                : false;
            if (!this.poseOnlyMode) this.resetSavedPoseSceneTracking();
            this.livePoseSceneContinuation = sceneContinuation && localSegmentWeight <= .01;
            const segmentWeight = Math.max(localSegmentWeight, sceneContinuation ? 1 : 0);
            const driftWeight = nearestDistance <= savedAnchorHoldSeconds
                ? 1 : drift > this.poseCorrectionDriftLimit
                    ? this.poseCorrectionDriftLimit / drift : 1;
            const correctionWeight = segmentWeight * driftWeight;
            this.livePoseCorrectionDrift = drift;
            this.livePoseCorrectionGuarded = driftWeight < .999;
            this.livePoseCorrectionApplied = correctionWeight > .01;
            if (!this.livePoseCorrectionApplied) return points;
            return points.map((point: any) => {
                const id = Number(point.id);
                if (!AI_POSTURE_KEY_IDS.includes(id)) return point;
                const beforePoint = beforeSaved.get(id);
                const beforeBase = beforeReference.get(id);
                const afterPoint = afterSaved.get(id);
                const afterBase = afterReference.get(id);
                if (![beforePoint, beforeBase, afterPoint, afterBase].every(value => this.isPoseVisible(value))) {
                    return point;
                }
                const offsetX = (Number(beforePoint.x) - Number(beforeBase.x)) * (1 - interpolation)
                    + (Number(afterPoint.x) - Number(afterBase.x)) * interpolation;
                const offsetY = (Number(beforePoint.y) - Number(beforeBase.y)) * (1 - interpolation)
                    + (Number(afterPoint.y) - Number(afterBase.y)) * interpolation;
                const articulatedCorrectionWeight = (
                    AI_POSTURE_ELBOW_IDS.includes(id) && this.livePoseSceneContinuation
                ) ? localSegmentWeight * driftWeight : correctionWeight;
                const trackedX = this.clamp(
                    Number(point.x) + offsetX * articulatedCorrectionWeight, 0, 1,
                );
                const trackedY = this.clamp(
                    Number(point.y) + offsetY * articulatedCorrectionWeight, 0, 1,
                );
                const fixed = nearestSaved.get(id);
                const guided = guidedBySavedSkeleton.get(id);
                const skeletonGuideTemporalWeight = this.clamp(
                    1 - (
                        Math.max(0, nearestDistance - savedSkeletonGuideHoldSeconds)
                        / savedSkeletonGuideFadeSeconds
                    ), 0, 1,
                );
                const guideDisagreement = guided
                    ? Math.hypot(trackedX - Number(guided.x), trackedY - Number(guided.y)) : 0;
                const sourceConfidence = this.clamp(Number(
                    point?.source_confidence ?? point?.confidence ?? 0,
                ), 0, 1);
                const unreliablePrediction = Math.max(
                    this.clamp((guideDisagreement - .015) / .08, 0, 1),
                    this.clamp((.6 - sourceConfidence) / .4, 0, 1),
                );
                const skeletonGuideWeight = guided ? this.clamp(
                    skeletonGuideTemporalWeight * correctionWeight
                    * (.45 + unreliablePrediction * .45), 0, .9,
                ) : 0;
                const guidedX = guided
                    ? trackedX * (1 - skeletonGuideWeight) + Number(guided.x) * skeletonGuideWeight
                    : trackedX;
                const guidedY = guided
                    ? trackedY * (1 - skeletonGuideWeight) + Number(guided.y) * skeletonGuideWeight
                    : trackedY;
                return {
                    ...point,
                    x: this.clamp(exactAnchorMatch ? Number(fixed.x) : guidedX, 0, 1),
                    y: this.clamp(exactAnchorMatch ? Number(fixed.y) : guidedY, 0, 1),
                    visibility: fixed.visibility || 'visible',
                    saved_correction_weight: articulatedCorrectionWeight,
                    saved_skeleton_guide_weight: exactAnchorMatch ? 1 : skeletonGuideWeight,
                    saved_correction_mode: exactAnchorMatch
                        ? 'saved_anchor_exact'
                        : skeletonGuideWeight > .01 ? 'saved_skeleton_guided_tracking'
                        : this.livePoseSceneContinuation
                        ? this.livePoseCorrectionGuarded
                            ? 'scene_continuous_drift_guarded_offset'
                            : 'scene_continuous_tracking_offset'
                        : this.livePoseCorrectionGuarded
                        ? 'drift_guarded_tracking_offset'
                        : betweenAnchors ? 'interpolated_tracking_offset'
                            : 'bounded_tracking_offset',
                    saved_anchor_count: compatible.length,
                    saved_segment_start_seconds: firstTime,
                    saved_segment_end_seconds: lastTime,
                    uncorrected_x: Number(point.x),
                    uncorrected_y: Number(point.y),
                };
            });
        }
        this.resetSavedPoseSceneTracking();
        const nearest = anchors.reduce((best: any, anchor: any) => (
            !best || Math.abs(sourceTime - Number(anchor.video_time_seconds))
                < Math.abs(sourceTime - Number(best.video_time_seconds)) ? anchor : best
        ), null);
        const distance = Math.abs(sourceTime - Number(nearest?.video_time_seconds || 0));
        if (!nearest || distance > savedAnchorHoldSeconds + legacyRadiusSeconds) return points;
        const legacyWeight = this.clamp(
            1 - (Math.max(0, distance - savedAnchorHoldSeconds) / legacyRadiusSeconds), 0, 1,
        );
        const savedById = this.posePointMap(nearest.pose_keypoints);
        this.livePoseCorrectionApplied = legacyWeight > .01;
        return points.map((point: any) => {
            const saved = savedById.get(Number(point.id));
            if (!AI_POSTURE_KEY_IDS.includes(Number(point.id)) || !this.isPoseVisible(saved)) return point;
            return {
                ...point,
                x: this.clamp((Number(point.x) * (1 - legacyWeight)) + (Number(saved.x) * legacyWeight), 0, 1),
                y: this.clamp((Number(point.y) * (1 - legacyWeight)) + (Number(saved.y) * legacyWeight), 0, 1),
                visibility: saved.visibility || 'visible',
                saved_correction_weight: legacyWeight,
                saved_correction_mode: 'legacy_anchor',
                uncorrected_x: Number(point.x),
                uncorrected_y: Number(point.y),
            };
        });
    }
    private resetSavedPoseSceneTracking() {
        this.savedPoseSceneTrackingState = null;
        this.livePoseSceneContinuation = false;
    }
    private continueSavedPoseCorrectionThroughScene(
        points: any[], sourceTime: number, localSegmentActive: boolean,
    ) {
        const currentPose = this.clone(points || []);
        const previous = this.savedPoseSceneTrackingState;
        if (!previous) {
            if (!localSegmentActive) return false;
            this.savedPoseSceneTrackingState = {
                lastSourceTime: sourceTime,
                lastPose: currentPose,
                discontinuityFrames: 0,
            };
            return false;
        }
        const elapsed = sourceTime - previous.lastSourceTime;
        const repeatedFrame = Math.abs(elapsed) <= .06;
        const sequential = elapsed >= -.06
            && elapsed <= this.poseSceneTrackingMaxFrameGapSeconds;
        if (!sequential) {
            this.resetSavedPoseSceneTracking();
            if (!localSegmentActive) return false;
            this.savedPoseSceneTrackingState = {
                lastSourceTime: sourceTime,
                lastPose: currentPose,
                discontinuityFrames: 0,
            };
            return false;
        }
        const continuous = repeatedFrame
            || this.poseFramesBelongToSameScene(previous.lastPose, currentPose);
        if (continuous) {
            previous.lastSourceTime = sourceTime;
            previous.lastPose = currentPose;
            previous.discontinuityFrames = 0;
            return !localSegmentActive;
        }
        if (localSegmentActive) {
            this.savedPoseSceneTrackingState = {
                lastSourceTime: sourceTime,
                lastPose: currentPose,
                discontinuityFrames: 0,
            };
            return false;
        }
        previous.lastSourceTime = sourceTime;
        previous.discontinuityFrames += 1;
        if (previous.discontinuityFrames < this.poseSceneTrackingDiscontinuityFrames) return true;
        this.resetSavedPoseSceneTracking();
        return false;
    }
    private poseFramesBelongToSameScene(previousPoints: any[], currentPoints: any[]) {
        const previous = this.poseSceneGeometry(previousPoints);
        const current = this.poseSceneGeometry(currentPoints);
        if (!previous || !current) return false;
        const centerStep = this.poseDistance(previous.center, current.center)
            / Math.max(.04, previous.span, current.span);
        const scaleRatio = current.span / previous.span;
        const torsoDrift = previous.lengths.reduce(
            (maximum: number, length: number, index: number) => Math.max(
                maximum,
                Math.abs(current.lengths[index] - length) / Math.max(.02, length),
            ), 0,
        );
        return centerStep <= this.poseSceneTrackingMaxCenterStep
            && scaleRatio >= this.poseSceneTrackingMinScaleRatio
            && scaleRatio <= this.poseSceneTrackingMaxScaleRatio
            && torsoDrift <= this.poseSceneTrackingMaxTorsoDrift;
    }
    private poseSceneGeometry(points: any[]) {
        const byId = this.posePointMap(points);
        const torsoIds = [11, 12, 23, 24];
        if (!torsoIds.every(id => this.isPoseVisible(byId.get(id)))) return null;
        const center = {
            x: torsoIds.reduce((sum, id) => sum + Number(byId.get(id).x), 0) / torsoIds.length,
            y: torsoIds.reduce((sum, id) => sum + Number(byId.get(id).y), 0) / torsoIds.length,
        };
        const pairs = [[11, 12], [11, 23], [12, 24], [23, 24]];
        const lengths = pairs.map(([fromId, toId]) => (
            this.poseDistance(byId.get(fromId), byId.get(toId))
        ));
        if (lengths.some(length => !Number.isFinite(length) || length < .02)) return null;
        return {
            center,
            span: lengths.reduce((sum, length) => sum + length, 0) / lengths.length,
            lengths,
        };
    }
    private poseCorrectionSkeletonDrift(points: any[], corrected: Map<number, any>) {
        const original = this.posePointMap(points);
        return AI_POSTURE_CONNECTIONS.reduce((maximum, [fromId, toId]) => {
            const originalLength = this.poseDistance(original.get(fromId), original.get(toId));
            const correctedLength = this.poseDistance(corrected.get(fromId), corrected.get(toId));
            if (!Number.isFinite(originalLength) || originalLength < .04
                || !Number.isFinite(correctedLength)) return maximum;
            return Math.max(maximum, Math.abs(correctedLength - originalLength) / originalLength);
        }, 0);
    }
    private posePointMap(points: any[]) {
        return new Map<number, any>((points || []).map(
            (point: any) => [Number(point.id), point],
        ));
    }
    private poseAnchorGuidedPointMap(
        points: any[], beforeSaved: Map<number, any>, beforeReference: Map<number, any>,
        afterSaved: Map<number, any>, afterReference: Map<number, any>, interpolation: number,
    ) {
        const current = this.posePointMap(points);
        const saved = new Map<number, any>();
        const reference = new Map<number, any>();
        AI_POSTURE_KEY_IDS.forEach(id => {
            const beforePoint = beforeSaved.get(id);
            const afterPoint = afterSaved.get(id);
            const beforeBase = beforeReference.get(id);
            const afterBase = afterReference.get(id);
            if (![beforePoint, afterPoint, beforeBase, afterBase].every(value => this.isPoseVisible(value))) {
                return;
            }
            saved.set(id, {
                x: Number(beforePoint.x) * (1 - interpolation) + Number(afterPoint.x) * interpolation,
                y: Number(beforePoint.y) * (1 - interpolation) + Number(afterPoint.y) * interpolation,
            });
            reference.set(id, {
                x: Number(beforeBase.x) * (1 - interpolation) + Number(afterBase.x) * interpolation,
                y: Number(beforeBase.y) * (1 - interpolation) + Number(afterBase.y) * interpolation,
            });
        });
        const torsoIds = [11, 12, 23, 24];
        if (!torsoIds.every(id => (
            saved.has(id) && reference.has(id) && this.isPoseVisible(current.get(id))
        ))) return new Map<number, any>();
        const center = (source: Map<number, any>) => ({
            x: torsoIds.reduce((sum, id) => sum + Number(source.get(id).x), 0) / torsoIds.length,
            y: torsoIds.reduce((sum, id) => sum + Number(source.get(id).y), 0) / torsoIds.length,
        });
        const span = (source: Map<number, any>) => {
            const shoulderCenter = {
                x: (Number(source.get(11).x) + Number(source.get(12).x)) / 2,
                y: (Number(source.get(11).y) + Number(source.get(12).y)) / 2,
            };
            const hipCenter = {
                x: (Number(source.get(23).x) + Number(source.get(24).x)) / 2,
                y: (Number(source.get(23).y) + Number(source.get(24).y)) / 2,
            };
            return (
                this.poseDistance(source.get(11), source.get(12))
                + this.poseDistance(source.get(23), source.get(24))
                + this.poseDistance(shoulderCenter, hipCenter)
            ) / 3;
        };
        const referenceCenter = center(reference);
        const currentCenter = center(current);
        const referenceSpan = span(reference);
        const currentSpan = span(current);
        const scale = Number.isFinite(referenceSpan) && referenceSpan > .02
            && Number.isFinite(currentSpan)
            ? this.clamp(currentSpan / referenceSpan, .8, 1.25) : 1;
        const guided = new Map<number, any>();
        AI_POSTURE_KEY_IDS.forEach(id => {
            const point = saved.get(id);
            if (!point) return;
            guided.set(id, {
                x: this.clamp(currentCenter.x + (Number(point.x) - referenceCenter.x) * scale, 0, 1),
                y: this.clamp(currentCenter.y + (Number(point.y) - referenceCenter.y) * scale, 0, 1),
            });
        });
        return guided;
    }
    private poseCorrectionAnchors() {
        const anchors = [...(this.videoPoseCorrections || [])].filter(
            (anchor: any) => this.poseOnlyMode || anchor?.finalized !== false,
        );
        const coordinates = this.current?.coordinate_draft || {};
        if (coordinates.pose_reviewed === true || coordinates.pose_draft === true) {
            anchors.push({
                image_id: this.current?.image_id,
                video_time_seconds: this.reviewFrameTime(),
                pose_keypoints: this.clone(this.draft?.pose_keypoints || []),
                pose_reference_keypoints: this.clone(coordinates.pose_reference_keypoints || []),
                pose_model_id: coordinates.pose_model_id || this.draft?.pose_model_id || '',
                pose_model_sha256: coordinates.pose_model_sha256 || this.draft?.pose_model_sha256 || '',
            });
        }
        const byKey = new Map<string, any>();
        anchors.forEach((anchor: any) => {
            const key = String(anchor.image_id || '') || Number(anchor.video_time_seconds).toFixed(3);
            byKey.set(key, anchor);
        });
        return [...byKey.values()].map((anchor: any) => ({
            ...anchor,
            pose_keypoints: (anchor.pose_keypoints || []).filter(
                (point: any) => AI_POSTURE_VIDEO_IDS.has(Number(point.id)),
            ),
            pose_reference_keypoints: (anchor.pose_reference_keypoints || []).filter(
                (point: any) => AI_POSTURE_VIDEO_IDS.has(Number(point.id)),
            ),
        })).filter((anchor: any) => (
            Number.isFinite(Number(anchor.video_time_seconds))
            && AI_POSTURE_KEY_IDS.every(id => this.isPoseVisible(
                this.posePointMap(anchor.pose_keypoints).get(id),
            ))
        )).sort((left: any, right: any) => (
            Number(left.video_time_seconds) - Number(right.video_time_seconds)
        ));
    }
    private filterAiPosturePoint(point: any, id: number, timestamp: number) {
        const confidence = this.clamp(Number(
            point?.source_confidence ?? point?.confidence ?? point?.visibility ?? point?.presence ?? 0,
        ), 0, 1);
        const previous = this.aiPosturePointStates.get(id);
        const keyJoint = AI_POSTURE_KEY_IDS.includes(id);
        const shoulderJoint = AI_POSTURE_SHOULDER_IDS.includes(id);
        const confidenceMinimum = keyJoint ? this.aiPostureCoreConfidenceMin : .12;
        const trackingMinimum = shoulderJoint ? this.aiPostureShoulderConfidenceMin : confidenceMinimum;
        if (confidence <= trackingMinimum && previous) {
            const staleMs = Math.max(0, timestamp - previous.lastVisibleAt);
            const holdLimit = shoulderJoint ? this.aiPostureShoulderHoldMs : this.aiPostureLowConfidenceHoldMs;
            const withinHold = staleMs <= holdLimit;
            if (withinHold) {
                const heldConfidence = Math.max(confidenceMinimum + .001, previous.confidence * .92);
                return {
                    id, x: previous.x.filtered, y: previous.y.filtered,
                    confidence: heldConfidence, source_confidence: confidence,
                    visibility: heldConfidence >= .10 ? 'visible' : 'not_labeled',
                    held: true, stale_ms: staleMs,
                };
            }
        }
        const medianPoint = this.medianAiPosturePoint(point, id);
        const rawX = medianPoint.x;
        const rawY = medianPoint.y;
        const x = this.filterAiPostureAxis(previous?.x, rawX, timestamp, id);
        const y = this.filterAiPostureAxis(previous?.y, rawY, timestamp, id);
        this.aiPosturePointStates.set(id, {
            x, y,
            lastVisibleAt: confidence > trackingMinimum ? timestamp : (previous?.lastVisibleAt || 0),
            confidence,
        });
        return {
            id, x: x.filtered, y: y.filtered, confidence, source_confidence: confidence,
            visibility: confidence >= .10 ? 'visible' : 'not_labeled', held: false, stale_ms: 0,
        };
    }
    private medianAiPosturePoint(point: any, id: number) {
        const current = this.aiPostureMedianWindows.get(id) || { x: [], y: [] };
        current.x.push(this.clamp(Number(point?.x ?? 0), 0, 1));
        current.y.push(this.clamp(Number(point?.y ?? 0), 0, 1));
        if (current.x.length > this.aiPostureMedianWindowSize) current.x.shift();
        if (current.y.length > this.aiPostureMedianWindowSize) current.y.shift();
        this.aiPostureMedianWindows.set(id, current);
        const median = (values: number[]) => {
            const sorted = [...values].sort((left, right) => left - right);
            const middle = Math.floor(sorted.length / 2);
            return sorted.length % 2 ? sorted[middle] : (sorted[middle - 1] + sorted[middle]) / 2;
        };
        return { x: median(current.x), y: median(current.y) };
    }
    private filterAiPostureAxis(
        previous: PoseFilterAxisState | undefined,
        raw: number,
        timestamp: number,
        pointId: number,
    ): PoseFilterAxisState {
        if (!previous) {
            return { raw, filtered: raw, derivative: 0, timestamp, microDirection: 0, microFrames: 0 };
        }
        const dt = Math.max(.001, (timestamp - previous.timestamp) / 1000);
        const delta = raw - previous.filtered;
        const direction = Math.sign(raw - previous.raw);
        const microFrames = direction === 0 ? 0
            : direction === previous.microDirection ? previous.microFrames + 1 : 1;
        const persistentMotion = microFrames >= this.aiPostureMicroMotionReleaseFrames;
        const shoulder = AI_POSTURE_SHOULDER_IDS.includes(pointId);
        const deadband = shoulder ? this.aiPostureShoulderDeadband : this.aiPostureStaticDeadband;
        if (Math.abs(delta) <= deadband && !persistentMotion) {
            return {
                raw, filtered: previous.filtered, derivative: previous.derivative * .5,
                timestamp, microDirection: direction, microFrames,
            };
        }
        const derivative = (raw - previous.raw) / dt;
        const derivativeAlpha = this.oneEuroAlpha(dt, 1);
        const filteredDerivative = derivativeAlpha * derivative + (1 - derivativeAlpha) * previous.derivative;
        const baseCutoff = shoulder ? 1.2 : 1.5;
        const beta = shoulder ? .08 : .12;
        const movingCutoff = shoulder ? 3.5 : 4.5;
        const adaptiveCutoff = baseCutoff + beta * Math.abs(filteredDerivative);
        const cutoff = persistentMotion ? Math.max(movingCutoff, adaptiveCutoff) : adaptiveCutoff;
        const alpha = this.oneEuroAlpha(dt, cutoff);
        return {
            raw, filtered: alpha * raw + (1 - alpha) * previous.filtered,
            derivative: filteredDerivative, timestamp,
            microDirection: direction, microFrames,
        };
    }
    private oneEuroAlpha(dt: number, cutoff: number) {
        const tau = 1 / (2 * Math.PI * cutoff);
        return 1 / (1 + tau / dt);
    }
    private clamp(value: number, minimum: number, maximum: number) {
        return Math.max(minimum, Math.min(maximum, value));
    }
    private syncVideoPosition(video: HTMLVideoElement) {
        this.videoCurrentTime = Number(video.currentTime || 0);
        const fps = Math.max(1, Number(this.current?.video_fps || 30));
        const tolerance = Math.max(.04, .55 / fps);
        this.videoAtReviewFrame = Math.abs(this.videoCurrentTime - this.reviewFrameTime()) <= tolerance;
        this.service.render();
    }
    private requireReviewFrameForEditing() {
        if (this.canEditCoordinates()) return true;
        this.errorMessage = '좌표는 대표 검수 프레임에서만 수정할 수 있습니다.';
        this.returnToReviewFrame();
        this.service.render();
        return false;
    }

    public currentPhotoName() {
        const row = this.items[this.currentIndex] || {};
        return String(this.current?.filename || row.filename || '파일명 없음');
    }

    public onImageLoad() { this.updateBaseImageSize(true); }
    private updateBaseImageSize(force: boolean) {
        const media = document.getElementById('normality-review-media') as HTMLImageElement | HTMLVideoElement;
        const viewport = document.getElementById('normality-zoom-viewport');
        if (!media || (!force && this.zoomScale !== 1)) return;
        const naturalWidth = media.tagName === 'VIDEO'
            ? Number((media as HTMLVideoElement).videoWidth)
            : Number((media as HTMLImageElement).naturalWidth);
        const naturalHeight = media.tagName === 'VIDEO'
            ? Number((media as HTMLVideoElement).videoHeight)
            : Number((media as HTMLImageElement).naturalHeight);
        const availableWidth = Math.max(1, Number(viewport?.clientWidth || 0) - 16);
        const availableHeight = Math.max(1, Number(viewport?.clientHeight || 0) - 16);
        if (naturalWidth > 0 && naturalHeight > 0 && availableWidth > 1 && availableHeight > 1) {
            const scale = Math.min(
                1,
                availableWidth / naturalWidth,
                availableHeight / naturalHeight
            );
            this.baseImageDisplay = {
                width: Math.floor(naturalWidth * scale),
                height: Math.floor(naturalHeight * scale),
            };
            this.service.render();
        }
    }
    public imageStageStyle() {
        if (!this.baseImageDisplay.width) return {};
        return { width: `${this.baseImageDisplay.width * this.zoomScale}px` };
    }
    public imageDisplayStyle() {
        return this.baseImageDisplay.width
            ? { width: '100%', maxWidth: 'none', maxHeight: 'none', height: 'auto' }
            : {};
    }
    public zoomPercent() { return Math.round(this.zoomScale * 100); }
    public zoomBy(delta: number) {
        this.zoomMode = 'manual';
        this.applyZoom(Math.max(1, Math.min(3.5, this.zoomScale + delta)));
    }
    public resetZoom() {
        this.zoomMode = 'full';
        this.applyZoom(1, () => {
            const viewport = document.getElementById('normality-zoom-viewport');
            if (viewport) { viewport.scrollLeft = 0; viewport.scrollTop = 0; }
        });
    }
    public focusUpperBody() {
        const points = (this.draft?.pose_keypoints || []).filter(
            (point: any) => (this.poseOnlyMode
                ? AI_POSTURE_VIDEO_IDS.has(Number(point.id))
                : PRIORITY_IDS.has(Number(point.id)))
                && this.isPoseVisible(point)
        );
        this.zoomMode = 'upper';
        this.applyZoom(2.2, () => this.scrollToPoints(points, 0.08));
    }
    public focusDetector() {
        const points = this.detectorPoints();
        if (points.length !== 4) {
            this.errorMessage = '디텍터 네 모서리를 먼저 지정해 주세요.';
            this.service.render(); return;
        }
        this.errorMessage = '';
        this.zoomMode = 'detector';
        this.applyZoom(2.4, () => this.scrollToPoints(points, 0));
    }
    private scrollToPoints(points: any[], topPadding: number) {
        const viewport = document.getElementById('normality-zoom-viewport');
        if (!viewport || !points.length) return;
        const centerX = points.reduce((sum, point) => sum + Number(point.x), 0) / points.length;
        const topY = Math.max(0, Math.min(...points.map(point => Number(point.y))) - topPadding);
        viewport.scrollLeft = Math.max(0, centerX * viewport.scrollWidth - viewport.clientWidth / 2);
        viewport.scrollTop = Math.max(0, topY * viewport.scrollHeight);
    }
    private applyZoom(scale: number, after?: () => void) {
        this.zoomScale = Number(scale.toFixed(2));
        this.service.render();
        setTimeout(() => { if (after) after(); }, 0);
    }

    public modelLabel(kind: 'pose' | 'detector') {
        const model = this.current?.model_coordinates || {};
        const id = kind === 'pose' && this.draft?.pose_model_id
            ? this.draft.pose_model_id
            : model[kind + '_model_id'] || '모델 정보 없음';
        if (kind === 'pose' && id === AI_POSTURE_POSE_MODEL_ID) {
            const confidenceValues = AI_POSTURE_KEY_IDS.map(pointId => this.posePoint(pointId))
                .map(point => Number(point?.source_confidence ?? point?.confidence ?? NaN))
                .filter(value => Number.isFinite(value));
            const confidence = confidenceValues.length
                ? Math.min(...confidenceValues)
                : NaN;
            return `사람이 저장한 관절 · 모델 초안 아님${Number.isFinite(confidence) ? ` · 핵심 ${(confidence * 100).toFixed(1)}%` : ''}`;
        }
        const raw = model[kind + '_confidence'];
        const confidence = raw == null || raw === '' ? NaN : Number(raw);
        if (kind === 'pose') {
            const allRaw = model.pose_all_keypoint_confidence;
            const all = allRaw == null || allRaw === '' ? NaN : Number(allRaw);
            const scores = [];
            if (Number.isFinite(confidence)) scores.push(`핵심 ${(confidence * 100).toFixed(1)}%`);
            if (Number.isFinite(all)) scores.push(`전체 ${(all * 100).toFixed(1)}%`);
            return `${id}${scores.length ? ` · ${scores.join(' / ')}` : ''}`;
        }
        return `${id}${Number.isFinite(confidence) ? ` · 객체 신뢰도 ${(confidence * 100).toFixed(1)}%` : ''}`;
    }
    public modelRequiresReview() {
        return this.current?.model_coordinates?.coordinate_review_required === true;
    }
    public reviewRequiresAttention() {
        if (this.poseOnlyMode && this.poseSuggestionSource === 'mediapipe_pose_33') {
            return AI_POSTURE_KEY_IDS.some(id => {
                const point = this.posePoint(id);
                return !this.isPoseVisible(point)
                    || Number(point?.source_confidence ?? point?.confidence ?? 0) < this.aiPostureCoreConfidenceMin;
            });
        }
        return this.poseOnlyMode
            ? this.current?.model_coordinates?.pose_review_required === true
            : this.modelRequiresReview();
    }
    public coordinateQualityMessage() {
        if (this.poseOnlyMode && this.poseSuggestionSource === 'mediapipe_pose_33') {
            return 'AI 자세판정 MediaPipe의 핵심 관절 신뢰도가 부족합니다.';
        }
        const model = this.current?.model_coordinates || {};
        const reasons = [];
        if (model.pose_review_required) reasons.push('핵심 Pose 관절 신뢰도가 부족합니다.');
        if (!this.poseOnlyMode && model.detector_review_required) {
            reasons.push(model.detector_panel_coverage_valid === false
                ? 'Bucky가 전체 촬영판이 아닌 일부 영역으로 검출됐습니다.'
                : 'Bucky와 사람 자세의 위치 관계가 불안정합니다.');
        }
        return reasons.join(' ') || '자동 좌표 품질을 사람이 확인해야 합니다.';
    }
    public automaticClass() { return this.draft?.automatic_judgement?.posture_class || ''; }
    public automaticReasons() {
        const automatic = this.draft?.automatic_judgement || {};
        const reasons = Array.isArray(automatic.abnormal_reasons)
            ? automatic.abnormal_reasons
            : [];
        const normalized = reasons.filter((value: string, index: number, rows: string[]) =>
            ABNORMAL_CLASSES.some(row => row.key === value) && rows.indexOf(value) === index);
        if (normalized.length) return normalized;
        const postureClass = this.automaticClass();
        return ABNORMAL_CLASSES.some(row => row.key === postureClass) ? [postureClass] : [];
    }
    public automaticConfidence() {
        const raw = this.draft?.automatic_judgement?.confidence;
        if (raw == null || raw === '') return '판정 불가';
        const value = Number(raw);
        return Number.isFinite(value) ? `${(value * 100).toFixed(1)}%` : '판정 불가';
    }
    public automaticReason() {
        return this.draft?.automatic_judgement?.reason || '자동 판정 근거가 없습니다.';
    }
    public hasTemporalAnalysis() {
        return Boolean(this.draft?.automatic_judgement?.temporal_analysis);
    }
    public usesReviewedVideoLabels() {
        return this.draft?.automatic_judgement?.temporal_analysis?.coordinate_source
            === 'HUMAN_REVIEWED_POSE_AND_BUCKY_LABELS';
    }
    public usesLabelGuidedFullVideoAnalysis() {
        return this.draft?.automatic_judgement?.temporal_analysis?.analysis_mode
            === 'FULL_VIDEO_LABEL_GUIDED';
    }
    public usesReviewedVideoLabelTracks() {
        return this.draft?.automatic_judgement?.temporal_analysis?.analysis_mode
            === 'REVIEWED_VIDEO_LABEL_TRACKS';
    }
    public automaticDraftTitle() {
        if (this.usesReviewedVideoLabelTracks()) return '동영상 구간 확정 라벨 관계 초안';
        if (this.usesLabelGuidedFullVideoAnalysis()) return '영상 전체 움직임 관계 초안';
        return this.usesReviewedVideoLabels()
            ? '확정 라벨 관계 초안'
            : '모델 좌표 자동 초안';
    }
    public automaticDraftGuide() {
        if (this.usesReviewedVideoLabelTracks()) {
            return '자세 모델과 디텍터 모델에서 저장한 동영상 구간별 확정 라벨을 현재 시점에 맞춰 전환·보간하고, 각 구간의 관계를 비교한 초안입니다.';
        }
        if (this.usesLabelGuidedFullVideoAnalysis()) {
            return '사람이 확정한 상체 관절과 Bucky 라벨을 기준점으로 사용해 영상 전 구간의 Pose 움직임을 다시 추론하고, 관계가 가장 크게 벗어난 시점을 자동 선택한 초안입니다. 맞으면 그대로 저장하고, 다르면 아래 정답을 선택해 수정하세요.';
        }
        return this.usesReviewedVideoLabels()
            ? '영상 전체를 다시 추론한 결과가 아니라, 사람이 저장한 상체 관절 시점과 가장 가까운 확정 Bucky 라벨을 결합해 계산한 관계 초안입니다. 맞으면 그대로 저장하고, 다르면 아래 정답을 선택해 수정하세요.'
            : '영상 전체 구간의 대표 시점을 비교하고 가장 확인이 필요한 시점을 자동 선택합니다. 맞으면 그대로 저장하고, 다르면 아래 정답을 선택해 수정하세요.';
    }
    public temporalAnalysisLabel() {
        const temporal = this.draft?.automatic_judgement?.temporal_analysis || {};
        const sampled = Number(temporal.sampled_frame_count || 0);
        const evaluable = Number(temporal.evaluable_frame_count || 0);
        const abnormal = Number(temporal.abnormal_frame_count || 0);
        const selectedTime = Number(temporal.selected_time_seconds || 0);
        if (temporal.analysis_mode === 'REVIEWED_VIDEO_LABEL_TRACKS') {
            const poseLabels = Number(temporal.pose_label_count || 0);
            const detectorLabels = Number(temporal.detector_anchor_count || 0);
            return `동영상 확정 라벨 관계 분석 · Pose ${poseLabels}개 시점 · Bucky ${detectorLabels}개 시점 · 대표 ${selectedTime.toFixed(1)}초`;
        }
        if (temporal.analysis_mode === 'FULL_VIDEO_LABEL_GUIDED') {
            return `영상 전체 움직임 ${sampled}개 시점 분석 · 판정 가능 ${evaluable}개 · 비정상 ${abnormal}개 · 대표 ${selectedTime.toFixed(1)}초`;
        }
        if (temporal.coordinate_source === 'HUMAN_REVIEWED_POSE_AND_BUCKY_LABELS') {
            const detectorTime = temporal.detector_label_time_seconds == null
                ? Number.NaN
                : Number(temporal.detector_label_time_seconds);
            const detectorLabel = Number.isFinite(detectorTime)
                ? ` · Bucky 라벨 ${detectorTime.toFixed(1)}초`
                : '';
            return `확정 라벨 관계 분석 · Pose 라벨 ${selectedTime.toFixed(1)}초${detectorLabel} · ${evaluable ? '판정 가능' : '판정 보류'}`;
        }
        return `영상 전체 구간 ${sampled}개 대표 시점 분석 · 판정 가능 ${evaluable}개 · 비정상 ${abnormal}개 · 대표 ${selectedTime.toFixed(1)}초`;
    }
    public isAutomaticSelection(value: string) {
        return !this.draft?.judgement_touched && (
            value === 'NORMAL'
                ? this.automaticClass() === 'NORMAL'
                : this.automaticReasons().includes(value)
        );
    }

    public posePoint(id: number) {
        return (this.draft?.pose_keypoints || []).find((point: any) => Number(point.id) === Number(id));
    }
    public pointName(id: number) { return KO_NAMES[Number(id)] || `관절 ${id}`; }
    public isPoseVisible(point: any) {
        const x = Number(point?.x), y = Number(point?.y);
        return point?.visibility !== 'not_labeled'
            && Number.isFinite(x) && Number.isFinite(y)
            && x >= 0 && x <= 1 && y >= 0 && y <= 1;
    }
    public visiblePosePoints() {
        const sixJointLabels = this.poseOnlyMode || this.usesExistingCoordinateLabels();
        const defaultIds = sixJointLabels ? AI_POSTURE_VIDEO_IDS : PRIORITY_IDS;
        return (this.draft?.pose_keypoints || []).filter(
            (point: any) => this.isPoseVisible(point)
                && (sixJointLabels
                    ? defaultIds.has(Number(point.id))
                    : this.showAllPoints || defaultIds.has(Number(point.id)))
        );
    }
    public editablePosePoints() {
        return this.poseOnlyMode || this.usesExistingCoordinateLabels()
            ? (this.draft?.pose_keypoints || []).filter((point: any) => AI_POSTURE_VIDEO_IDS.has(Number(point.id)))
            : (this.draft?.pose_keypoints || []);
    }
    public poseCoordinateSourceLabel() {
        if (this.usesExistingCoordinateLabels()) return '기존 자세·디텍터 확정 라벨 그대로';
        return this.poseSuggestionSource === 'mediapipe_pose_33'
            ? 'AI 자세판정 MediaPipe 좌표'
            : '운영 모델 좌표 그대로';
    }
    public usesExistingCoordinateLabels() {
        const source = String(this.current?.coordinate_draft?.coordinate_source || '');
        return source === 'HUMAN_REVIEWED_POSE_AND_BUCKY_LABELS'
            || source === 'HUMAN_CONFIRMED_MODEL_COORDINATES';
    }
    public coordinateEditorTitle() {
        return this.usesExistingCoordinateLabels() ? '1. 기존 확정 라벨 확인' : '1. 모델 좌표 확인·수정';
    }
    public coordinateEditorGuide() {
        if (this.usesExistingCoordinateLabels()) {
            return '자세 모델에서 저장한 상체 관절과 디텍터 모델에서 저장한 Bucky 모서리를 그대로 불러왔습니다. 필요한 경우에만 수정하세요.';
        }
        return this.poseOnlyMode
            ? '하늘색 Pose 관절이 사람의 실제 위치에 맞는지 확인하세요.'
            : '관계 판정 전에 하늘색 Pose와 주황색 Bucky가 실제 위치에 맞는지 확인하세요.';
    }
    public resetCoordinateLabel() {
        return this.usesExistingCoordinateLabels() ? '확정 라벨 복원' : '모델 좌표 복원';
    }
    public skeletonEdges() {
        const connections = this.poseOnlyMode || this.usesExistingCoordinateLabels()
            ? AI_POSTURE_CONNECTIONS
            : XRAY_OPERATING_POSE_CONNECTIONS;
        return connections.map(([fromId, toId]) => ({
            from: this.posePoint(Number(fromId)), to: this.posePoint(Number(toId)),
        })).filter((edge: any) => this.isPoseVisible(edge.from) && this.isPoseVisible(edge.to));
    }
    public pointStyle(point: any) {
        return { left: `${Number(point.x) * 100}%`, top: `${Number(point.y) * 100}%` };
    }
    public selectPoint(id: number) { this.selectedPointId = Number(id); this.service.render(); }
    public selectedPoint() { return this.posePoint(this.selectedPointId); }
    public togglePoseMode() { this.showAllPoints = !this.showAllPoints; this.service.render(); }
    public setSelectedVisibility(value: string) {
        if (!this.requireReviewFrameForEditing()) return;
        const point = this.selectedPoint();
        if (!point) return;
        point.visibility = value;
        if (value !== 'not_labeled' && (!Number(point.x) && !Number(point.y))) {
            const defaults: any = {
                0: {x: .5, y: .2}, 11: {x: .42, y: .32}, 12: {x: .58, y: .32},
                13: {x: .36, y: .46}, 14: {x: .64, y: .46},
                23: {x: .44, y: .58}, 24: {x: .56, y: .58},
            };
            Object.assign(point, defaults[Number(point.id)] || {x: .5, y: .45});
        }
        this.markCorrected(); this.service.render();
    }
    public beginPose(event: PointerEvent, id: number) {
        if (!this.requireReviewFrameForEditing()) return;
        event.preventDefault(); event.stopPropagation();
        this.detectorCaptureMode = false;
        this.selectedPointId = Number(id);
        this.dragMode = 'pose'; this.dragPointId = Number(id);
        this.updatePoseFromEvent(event);
    }

    public detectorPoints(value: any = this.draft?.detector_polygon) {
        if (!value) return [];
        return DETECTOR_CORNERS.map(name => ({ name, ...(value[name] || {}) })).filter(
            point => Number.isFinite(Number(point.x)) && Number.isFinite(Number(point.y))
        );
    }
    public detectorPolygonString() {
        return this.detectorPoints().map(point => `${Number(point.x)},${Number(point.y)}`).join(' ');
    }
    public detectorCornerLabel(name: string) { return CORNER_LABELS[name] || name; }
    public detectorBboxStyle() {
        const box = this.draft?.detector_bbox;
        return box ? {
            left: `${Number(box.x) * 100}%`, top: `${Number(box.y) * 100}%`,
            width: `${Number(box.width) * 100}%`, height: `${Number(box.height) * 100}%`,
        } : {};
    }
    public beginDetectorCorner(event: PointerEvent, name: string) {
        if (!this.requireReviewFrameForEditing()) return;
        event.preventDefault(); event.stopPropagation();
        this.detectorCaptureMode = false;
        this.dragMode = 'detector-corner'; this.dragHandle = name;
    }
    public beginDetectorMove(event: PointerEvent) {
        if (!this.requireReviewFrameForEditing()) return;
        event.preventDefault(); event.stopPropagation();
        const point = this.coordinate(event);
        if (!point || this.detectorPoints().length !== 4) return;
        this.dragMode = 'detector-move';
        this.dragStart = { coordinate: point, polygon: this.clone(this.draft.detector_polygon) };
    }
    public startDetectorCapture() {
        if (!this.requireReviewFrameForEditing()) return;
        this.editLayer = 'detector';
        this.detectorCaptureMode = true; this.detectorCaptureIndex = 0;
        this.draft.detector_polygon = {};
        this.draft.detector_bbox = null;
        this.markCorrected(); this.service.render();
    }
    public captureDetectorPoint(event: PointerEvent) {
        if (!this.detectorCaptureMode) return;
        if (!this.requireReviewFrameForEditing()) return;
        const point = this.coordinate(event);
        if (!point) return;
        const name = DETECTOR_CORNERS[this.detectorCaptureIndex];
        this.draft.detector_polygon[name] = point;
        this.detectorCaptureIndex += 1;
        if (this.detectorCaptureIndex >= DETECTOR_CORNERS.length) {
            this.detectorCaptureMode = false; this.syncDetectorBbox();
        }
        this.markCorrected(); this.service.render();
    }
    private syncDetectorBbox() {
        const points = this.detectorPoints();
        if (points.length !== 4) { this.draft.detector_bbox = null; return; }
        const xs = points.map(point => Number(point.x));
        const ys = points.map(point => Number(point.y));
        this.draft.detector_bbox = {
            x: Math.min(...xs), y: Math.min(...ys),
            width: Math.max(...xs) - Math.min(...xs),
            height: Math.max(...ys) - Math.min(...ys),
        };
    }

    public resetCoordinatesToModel() {
        const model = this.current?.model_coordinates || {};
        const operatingSuggestion = this.isVideo() && this.reviewFramePoseSuggestion.length === 33
            ? this.reviewFramePoseSuggestion
            : null;
        this.draft.pose_keypoints = this.clone(operatingSuggestion || model.pose_keypoints || []);
        this.draft.pose_model_id = model.pose_model_id || '';
        this.draft.pose_model_sha256 = model.pose_model_sha256 || '';
        this.poseSuggestionSource = '';
        this.draft.detector_polygon = this.clone(model.detector_polygon || null);
        this.draft.detector_bbox = this.clone(model.detector_bbox || null);
        this.draft.coordinate_corrected = false;
        this.draft.coordinate_confirmed = false;
        this.draft.automatic_judgement_stale = false;
        this.detectorCaptureMode = false;
        this.notice = this.poseOnlyMode
            ? '현재 운영 자세 모델 좌표로 되돌렸습니다.'
            : '현재 운영 Pose·디텍터 모델 좌표로 되돌렸습니다.';
        this.errorMessage = '';
        this.service.render();
    }

    private coordinate(event: PointerEvent) {
        const media = document.getElementById('normality-review-media') as HTMLElement;
        if (!media) return null;
        const rect = media.getBoundingClientRect();
        if (!rect.width || !rect.height) return null;
        return {
            x: Math.max(0, Math.min(1, (event.clientX - rect.left) / rect.width)),
            y: Math.max(0, Math.min(1, (event.clientY - rect.top) / rect.height)),
        };
    }
    private onPointerMove(event: PointerEvent) {
        if (this.dragMode === 'pose') { this.updatePoseFromEvent(event); return; }
        if (this.dragMode === 'detector-corner') {
            const point = this.coordinate(event);
            if (!point || !this.draft?.detector_polygon?.[this.dragHandle]) return;
            this.draft.detector_polygon[this.dragHandle] = point;
            this.syncDetectorBbox(); this.markCorrected(); this.service.render(); return;
        }
        if (this.dragMode === 'detector-move') {
            const point = this.coordinate(event); const start = this.dragStart;
            if (!point || !start?.polygon) return;
            const original = this.detectorPoints(start.polygon);
            const minX = Math.min(...original.map(item => Number(item.x)));
            const maxX = Math.max(...original.map(item => Number(item.x)));
            const minY = Math.min(...original.map(item => Number(item.y)));
            const maxY = Math.max(...original.map(item => Number(item.y)));
            const dx = Math.max(-minX, Math.min(1 - maxX, point.x - start.coordinate.x));
            const dy = Math.max(-minY, Math.min(1 - maxY, point.y - start.coordinate.y));
            for (const item of original) {
                this.draft.detector_polygon[item.name] = { x: Number(item.x) + dx, y: Number(item.y) + dy };
            }
            this.syncDetectorBbox(); this.markCorrected(); this.service.render();
        }
    }
    private updatePoseFromEvent(event: PointerEvent) {
        const point = this.coordinate(event); const target = this.posePoint(this.dragPointId);
        if (!point || !target) return;
        target.x = point.x; target.y = point.y; target.visibility = 'visible';
        this.markCorrected(); this.service.render();
    }
    private endDrag() {
        this.dragMode = ''; this.dragHandle = ''; this.dragPointId = -1; this.dragStart = null;
    }
    private markCorrected() {
        this.draft.coordinate_corrected = true;
        this.draft.coordinate_confirmed = true;
        this.draft.automatic_judgement_stale = true;
    }

    public confirmCoordinates() {
        if (!this.requireReviewFrameForEditing()) return;
        this.draft.coordinate_confirmed = true;
        this.notice = this.poseOnlyMode
            ? '현재 Pose 관절 좌표를 사람이 확인했습니다.'
            : '현재 Pose·Bucky 좌표를 사람이 확인했습니다.';
        this.errorMessage = '';
        this.service.render();
    }

    public selectPostureClass(value: string) {
        if (value === 'NORMAL') {
            this.draft.decision = 'NORMAL'; this.draft.posture_class = 'NORMAL'; this.draft.abnormal_reasons = [];
        } else {
            const selected = this.draft.decision === 'ABNORMAL' ? [...(this.draft.abnormal_reasons || [])] : [];
            const index = selected.indexOf(value);
            if (index >= 0) selected.splice(index, 1); else selected.push(value);
            this.draft.abnormal_reasons = selected;
            this.draft.decision = selected.length ? 'ABNORMAL' : '';
            this.draft.posture_class = selected[0] || '';
        }
        this.draft.judgement_touched = true;
        const automaticReasons = this.automaticReasons();
        const selectedReasons = [...(this.draft.abnormal_reasons || [])].sort();
        this.draft.judgement_corrected = this.draft.decision === 'NORMAL'
            ? this.automaticClass() !== 'NORMAL'
            : selectedReasons.join('|') !== [...automaticReasons].sort().join('|');
        this.draft.automatic_judgement_stale = false;
        this.service.render();
    }
    public isPostureSelected(value: string) {
        return value === 'NORMAL'
            ? this.draft.decision === 'NORMAL'
            : this.draft.decision === 'ABNORMAL' && (this.draft.abnormal_reasons || []).includes(value);
    }
    public selectHold() {
        this.draft.decision = 'HOLD'; this.draft.posture_class = ''; this.draft.abnormal_reasons = [];
        this.draft.judgement_touched = true;
        this.draft.judgement_corrected = Boolean(this.automaticClass());
        this.draft.automatic_judgement_stale = false;
        this.service.render();
    }
    public coordinatesReady() {
        const requiredPoseIds = this.poseOnlyMode ? AI_POSTURE_KEY_IDS : [11, 12, 23, 24];
        const pointsReady = requiredPoseIds.every(id => this.isPoseVisible(this.posePoint(id)))
            && (this.poseOnlyMode || this.detectorPoints().length === 4);
        if (this.poseOnlyMode) return pointsReady;
        const qualityConfirmed = !this.reviewRequiresAttention()
            || this.draft.coordinate_corrected
            || this.draft.coordinate_confirmed;
        return pointsReady && qualityConfirmed;
    }
    public canSave() {
        if (this.poseOnlyMode) return Boolean(this.current) && this.coordinatesReady();
        if (!this.current || !['NORMAL', 'ABNORMAL', 'HOLD'].includes(this.draft?.decision)) return false;
        if (this.draft.decision === 'HOLD') return true;
        const classReady = this.draft.decision === 'NORMAL'
            || (this.draft.decision === 'ABNORMAL'
                && this.draft.abnormal_reasons.length > 0
                && this.draft.abnormal_reasons.every((value: string) => ABNORMAL_CLASSES.some(row => row.key === value)));
        return classReady && this.coordinatesReady();
    }
    public reasonCount(code: string) { return Number(this.summary?.reason_counts?.[code] || 0); }
    public reasonMissing(code: string) { return Number(this.summary?.missing?.reasons?.[code] || 0); }

    public async importImages(event: Event) {
        const input = event.target as HTMLInputElement;
        const files = Array.from(input.files || []);
        if (!files.length || this.uploadBusy) return;
        this.uploadBusy = true; this.errorMessage = ''; this.notice = '';
        this.uploadProgress = { current: 0, total: files.length };
        await this.service.render();
        let importedImages = 0; let importedVideos = 0; let importedFrames = 0; let duplicates = 0;
        try {
            for (const file of files) {
                const form = new FormData(); form.append('file', file, file.name);
                const { code, data } = await this.callRuntime('import_image', form);
                if (code !== 200) throw new Error(data?.message || file.name + ' 파일을 가져오지 못했습니다.');
                const result = data?.result || {};
                if (!result.imported) duplicates += 1;
                else if (result.media_type === 'video') {
                    importedVideos += 1;
                    importedFrames += Number(result.imported_frame_count || 0);
                } else importedImages += 1;
                this.summary = data?.summary || this.summary;
                this.uploadProgress.current += 1;
                await this.service.render();
            }
            const parts = [];
            if (importedImages) parts.push(`사진 ${importedImages}장`);
            if (importedVideos) parts.push(`동영상 ${importedVideos}개에서 대표 프레임 ${importedFrames}장`);
            const completedNotice = `${parts.length ? parts.join(', ') : '새 검수 항목 0건'}을 가져왔습니다.${duplicates ? ` 중복 파일 ${duplicates}개는 제외했습니다.` : ''}`;
            this.currentIndex = 0; await this.load(); this.notice = completedNotice;
        } catch (error: any) {
            this.errorMessage = error?.message || '새 검수 미디어를 가져오지 못했습니다.';
        }
        input.value = ''; this.uploadBusy = false; await this.service.render();
    }

    private rememberReviewItem(imageId: string) {
        this.requestedReviewItemId = imageId;
        const url = new URL(window.location.href);
        url.searchParams.set('review_item', imageId);
        window.history.replaceState({}, '', url.toString());
    }
    private forgetRememberedReviewItem() {
        this.requestedReviewItemId = '';
        const url = new URL(window.location.href);
        url.searchParams.delete('review_item');
        window.history.replaceState({}, '', url.toString());
    }

    private applyCommittedPoseFrame(
        committedId: string, data: any, finalized: boolean, fallbackCoordinate: any = null,
    ) {
        const result = data?.result || {};
        const responseCoordinate = data?.item?.coordinate_review;
        const savedCoordinate = responseCoordinate && Object.keys(responseCoordinate).length
            ? responseCoordinate : this.clone(fallbackCoordinate || {});
        const committedCurrent = {
            ...this.current,
            image_id: committedId,
            filename: result.filename || this.current?.filename,
            status: finalized ? 'REVIEWED' : 'UNREVIEWED',
            pose_reviewed: finalized,
            video_frame_index: result.video_frame_index ?? this.current?.video_frame_index,
            video_frame_slot_id: result.video_frame_slot_id || this.current?.video_frame_slot_id,
            video_time_seconds: result.video_time_seconds ?? this.current?.video_time_seconds,
            coordinate_draft: {
                ...(this.current?.coordinate_draft || {}),
                ...savedCoordinate,
                pose_draft: !finalized,
                pose_reviewed: finalized,
                coordinate_confirmed: true,
                coordinate_source: finalized
                    ? 'HUMAN_CONFIRMED_POSE_COORDINATES'
                    : 'HUMAN_SAVED_POSE_DRAFT',
            },
        };
        this.current = committedCurrent;
        this.items[this.currentIndex] = {
            ...(this.items[this.currentIndex] || {}),
            image_id: committedId,
            filename: committedCurrent.filename,
            status: finalized ? 'REVIEWED' : 'UNREVIEWED',
            pose_reviewed: finalized,
            video_frame_index: committedCurrent.video_frame_index,
            video_frame_slot_id: committedCurrent.video_frame_slot_id,
            video_time_seconds: committedCurrent.video_time_seconds,
        };
        this.draft.coordinate_confirmed = true;
        this.draft.coordinate_corrected = Boolean(savedCoordinate.coordinate_corrected);
        this.draft.pose_model_id = savedCoordinate.pose_model_id
            || this.draft.pose_model_id;
        this.draft.pose_model_sha256 = savedCoordinate.pose_model_sha256
            || this.draft.pose_model_sha256;
        this.detailCache.set(committedId, committedCurrent);
        this.videoCurrentTime = 0;
        this.videoAtReviewFrame = this.reviewFrameTime() <= .04;
        this.videoPlaying = false;
    }
    private async reloadSavedPoseVideo() {
        this.videoLoadVersion += 1;
        const version = this.videoLoadVersion;
        this.stopLiveInference(true);
        this.releaseVideoObjectUrl();
        this.videoPlaying = false;
        this.videoPlaybackStarted = false;
        this.videoCurrentTime = 0;
        this.videoAtReviewFrame = this.reviewFrameTime() <= .04;
        this.videoLoadError = false;
        this.videoPreparing = true;
        this.zoomScale = 1;
        this.zoomMode = 'full';
        await this.service.render();
        await this.prepareVideoPlayback(version);
    }

    public async save(advance = true) {
        if (!this.canSave() || this.saving) return;
        this.saving = true;
        this.savingAction = advance ? 'next' : 'current';
        this.errorMessage = ''; this.notice = '';
        await this.service.render();
        const savedId = this.current.image_id;
        try {
            const operatingPose = this.current?.model_coordinates || {};
            const poseReferenceKeypoints = this.pendingVideoFrame?.poseReferenceKeypoints
                || (this.reviewFramePoseSuggestion.length === 33
                    ? this.reviewFramePoseSuggestion
                    : this.current?.coordinate_draft?.pose_reference_keypoints);
            const savedPoseModelId = this.pendingVideoFrame
                ? (this.draft.pose_model_id || operatingPose.pose_model_id)
                : (operatingPose.pose_model_id || this.draft.pose_model_id);
            const savedPoseModelSha256 = this.pendingVideoFrame
                ? (this.draft.pose_model_sha256 || operatingPose.pose_model_sha256 || '')
                : (operatingPose.pose_model_sha256 || this.draft.pose_model_sha256 || '');
            const payload = {
                decision: this.draft.decision,
                abnormal_reasons: this.draft.abnormal_reasons,
                note: this.draft.note,
                coordinate_review: {
                    pose_keypoints: this.draft.pose_keypoints,
                    pose_reference_keypoints: poseReferenceKeypoints,
                    detector_polygon: this.draft.detector_polygon,
                    coordinate_corrected: this.draft.coordinate_corrected,
                    coordinate_confirmed: this.draft.coordinate_confirmed,
                    pose_model_id: savedPoseModelId,
                    pose_model_sha256: savedPoseModelSha256,
                    detector_model_id: this.draft.detector_model_id || this.current?.model_coordinates?.detector_model_id,
                    detector_model_sha256: this.draft.detector_model_sha256 || this.current?.model_coordinates?.detector_model_sha256,
                },
            };
            let saveRequest: any = {
                image_id: savedId,
                operation: this.poseOnlyMode
                    ? (advance ? 'save_pose' : 'save_pose_draft')
                    : 'save_relation',
                review_mode: this.poseOnlyMode ? 'pose' : 'judgement',
                review: JSON.stringify(payload),
            };
            if (this.poseOnlyMode && this.pendingVideoFrame?.blob) {
                const form = new FormData();
                form.append('operation', 'save_pose_video_frame');
                form.append('image_id', this.pendingVideoFrame.imageId || savedId);
                form.append('time_seconds', String(this.pendingVideoFrame.timeSeconds));
                form.append('source_video_sha256', this.pendingVideoFrame.sourceVideoSha256 || '');
                form.append('video_frame_index', String(this.pendingVideoFrame.videoFrameIndex ?? ''));
                form.append('video_frame_slot_id', this.pendingVideoFrame.videoFrameSlotId || '');
                form.append('complete_review', advance ? 'true' : 'false');
                form.append('review', JSON.stringify(payload));
                form.append('frame', this.pendingVideoFrame.blob, 'pose-review-frame.jpg');
                saveRequest = form;
            }
            const { code, data } = await this.callRuntime('save', saveRequest);
            if (code !== 200) throw new Error(data?.message || '검수 결과를 저장하지 못했습니다.');
            this.detailCache.delete(savedId);
            const committedId = String(data?.result?.image_id || savedId);
            this.detailCache.delete(committedId);
            this.pendingVideoFrame = null;
            this.summary = data?.summary || this.summary;
            const savedLabels = this.poseOnlyMode ? '자세 관절 좌표' : this.draft.decision === 'ABNORMAL'
                ? this.draft.abnormal_reasons.map((value: string) => this.postureClassLabel(value)).join(', ')
                : this.postureClassLabel(this.draft.decision);
            this.notice = savedLabels + ' 정답을 저장했습니다.';
            if (!advance) {
                this.applyCommittedPoseFrame(committedId, data, false, payload.coordinate_review);
                this.rememberReviewItem(committedId);
                await this.loadVideoPoseCorrections();
                this.saving = false;
                this.savingAction = '';
                this.notice = `현재 ${this.reviewFrameTime().toFixed(1)}초에 저장한 파란 관절로 동영상을 새로고침했습니다. 재생하면 저장 좌표 기준의 초록 관절을 다시 확인할 수 있습니다.`;
                await this.reloadSavedPoseVideo();
                return;
            }
            this.forgetRememberedReviewItem();
            if (this.statusFilter === 'UNREVIEWED') {
                this.items = this.items.filter((item: any) => item.image_id !== savedId);
                this.currentIndex = Math.min(this.currentIndex, Math.max(0, this.items.length - 1));
                this.saving = false;
                this.loadingNext = true;
                await this.service.render();
                await this.openCurrent(false);
                this.loadingNext = false;
            } else {
                this.saving = false;
                await this.load();
            }
        } catch (error: any) {
            this.errorMessage = error?.message || '검수 결과를 저장하지 못했습니다.';
        }
        this.saving = false;
        this.savingAction = '';
        this.loadingNext = false;
        await this.service.render();
    }

    public saveCurrentFrame(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        return this.save(false);
    }

    public saveAndNext(event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        return this.save(true);
    }
}

export default PageXrayNormality_reviewComponent;